export const guabook1 = [
    {
        id : "1",
        code : "111111",
        book : "上經", 
        name: "乾",
        fullName: "乾為天",
        gua: "【卦辭】：元，亨，利，貞",
        tuan: "【彖】：大哉乾元，萬物資始，乃統天。雲行雨施，品物流形，大明終始，六位時成，時乘六龍以御天。乾道變化，各正性命，保合大和，乃利貞。首出庶物，萬國咸寧。",
        xiang: "【象】：天行健，君子以自強不息。潛龍勿用，陽在下也。見龍在田，德施普也。終日乾乾，反復道也。或躍在淵，進无咎也，飛龍在天，大人造也。亢龍有悔，盈不可久也。用九，天德不可為首也。",
        yao1: "【初九】：潛龍勿用。",
        yao2: "【九二】：見龍在田，利見大人。",
        yao3: "【九三】：君子終日乾乾，夕惕若，厲无咎。",
        yao4: "【九四】：或躍在淵，无咎。",
        yao5: "【九五】：飛龍在天，利見大人。",
        yao6: "【上九】：亢龍有悔。",
        yaoXiang1: "【象】：潛龍勿用，陽在下也。",
        yaoXiang2: "【象】：見龍在田，德施普也。",
        yaoXiang3: "【象】：終日乾乾，反復道也。",
        yaoXiang4: "【象】：或躍在淵，進无咎也。",
        yaoXiang5: "【象】：飛龍在天，大人造也。",
        yaoXiang6: "【象】：亢龍有悔，盈不可久也。",
        yong9: "【用九】：見群龍无首，吉。",
        yong6: ""
    },
    {
        id: "2",
        code : "000000",
        book : "上經", 
        name: "坤",
        fullName: "坤為地",
        gua: "【卦辭】：元亨，利牝馬之貞。君子有攸往。先迷後得，主利，西南得朋，東北喪朋，安貞吉。",
        tuan: "【彖】：至哉坤元，萬物資生，乃順承天。坤厚載物，德合无疆，含弘光大，品物咸亨。牝馬地類，行地无疆，柔順利貞。君子攸行，先迷失道，後順得常。西南得朋，乃與類行，東北喪朋，乃終有慶。安貞之吉，應地无疆。",
        xiang: "【象】：地勢坤，君子以厚德載物。",
        yao1: "【初六】：履霜，堅冰至。",
        yao2: "【六二】：直方大，不習无不利。",
        yao3: "【六三】：含章可貞，或從王事，无成有終。",
        yao4: "【六四】：括囊，无咎无譽。",
        yao5: "【六五】：黃裳，元吉。",
        yao6: "【上六】：龍戰于野，其血玄黃。",
        yaoXiang1: "【象】：履霜堅冰，陰始凝也。馴致其道，至堅冰也。",
        yaoXiang2: "【象】：六二之動，直以方也。不習无不利，地道光也。",
        yaoXiang3: "【象】：含章可貞，以時發也；或從王事，知光大也。",
        yaoXiang4: "【象】：括囊无咎，慎不害也。",
        yaoXiang5: "【象】：黃裳元吉，文在中也。",
        yaoXiang6: "【象】：龍戰于野，其道窮也。",
        yong9: "",
        yong6: "【用六】：利永貞。"
    },
    {
        id: "3",
        code : "100010",
        book : "上經", 
        name: "屯",
        fullName: "水雷屯",
        gua: "【卦辭】：元亨利貞，勿用有攸往，利建侯。",
        tuan: "【彖】：屯，剛柔始交而難生，動乎險中，大亨貞。雷雨之動滿盈，天造草昧，宜建侯而不寧。",
        xiang: "【象】：雲雷屯，君子以經綸。",
        yao1: "【初九】：磐桓，利居貞，利建侯。",
        yao2: "【六二】：屯如邅如，乘馬班如，匪寇婚媾。女子貞不字，十年乃字。",
        yao3: "【六三】：即鹿无虞，惟入于林中。君子幾不如舍。往吝。",
        yao4: "【六四】：乘馬班如，求婚媾，往，吉无不利。",
        yao5: "【九五】：屯其膏，小貞吉，大貞凶。",
        yao6: "【上六】：乘馬班如，泣血漣如。",
        yaoXiang1: "【象】：雖磐桓，志行正也。以貴下賤，大得民也。",
        yaoXiang2: "【象】：六二之難，乘剛也。十年乃字，反常也。",
        yaoXiang3: "【象】：即鹿无虞，以從禽也。君子舍之，往吝窮也。",
        yaoXiang4: "【象】：求而往，明也。",
        yaoXiang5: "【象】：屯其膏，施未光也。",
        yaoXiang6: "【象】：泣血漣如，何可長也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "4",
        code : "010001",
        book : "上經", 
        name: "蒙",
        fullName: "山水蒙",
        gua: "【卦辭】：亨。匪我求童蒙，童蒙求我。初筮告，再三瀆，瀆則不告。利貞。",
        tuan: "【彖】：蒙，山下有險，險而止，蒙。蒙，亨，以亨行，時中也。匪我求童蒙，童蒙求我，志應也。初筮告，以剛中也。再三瀆，瀆則不告，瀆蒙也。蒙以養正，聖功也。",
        xiang: "【象】：山下出泉，蒙，君子以果行育德。",
        yao1: "【初六】：發蒙。利用刑人，用說桎梏，以往吝。",
        yao2: "【九二】：包蒙，吉。納婦吉，子克家。",
        yao3: "【六三】：勿用取女，見金夫，不有躬，无攸利。",
        yao4: "【六四】：困蒙，吝。",
        yao5: "【六五】：童蒙，吉。",
        yao6: "【上九】：擊蒙，不利為寇，利禦寇。",
        yaoXiang1: "【象】：利用刑人，以正法也。",
        yaoXiang2: "【象】：子克家，剛柔接也。",
        yaoXiang3: "【象】：勿用取女，行不順也。",
        yaoXiang4: "【象】：困蒙之吝，獨遠實也。",
        yaoXiang5: "【象】：童蒙之吉，順以巽也。",
        yaoXiang6: "【象】：利用禦寇，上下順也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "5",
        code : "111010",
        book : "上經", 
        name: "需",
        fullName: "水天需",
        gua: "【卦辭】：有孚，光亨，貞吉，利涉大川。",
        tuan: "【彖】：需，須也，險在前也。剛健而不陷，其義不困窮矣。需，有孚，光亨，貞吉，位乎天位，以正中也。利涉大川，往有功也。",
        xiang: "【象】：雲上於天，需，君子以飲食宴樂。",
        yao1: "【初九】：需于郊，利用恒，无咎。",
        yao2: "【九二】：需于沙，小有言，終吉。",
        yao3: "【九三】：需于泥，致寇至。",
        yao4: "【六四】：需于血，出自穴。",
        yao5: "【九五】：需于酒食，貞吉。",
        yao6: "【上六】：入于穴，有不速之客三人來，敬之，終吉。",
        yaoXiang1: "【象】：需于郊，不犯難行也。利用恆，无咎，未失常也。",
        yaoXiang2: "【象】：需于沙，衍在中也，雖小有言，以吉終也*。　*「以吉終也」或作「終吉也」。",
        yaoXiang3: "【象】：需于泥，災在外也。自我致寇，敬慎不敗也。",
        yaoXiang4: "【象】：需于血，順以聽也。",
        yaoXiang5: "【象】：酒食貞吉，以中正也。",
        yaoXiang6: "【象】：不速之客來，敬之終吉，雖不當位，未大失也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "6",
        code : "010111",
        book : "上經", 
        name: "訟",
        fullName: "天水訟",
        gua: "【卦辭】：訟，有孚窒惕，中吉，終凶。利見大人，不利涉大川。",
        tuan: "【彖】：訟，上剛下險，險而健，訟。訟有孚窒惕中吉，剛來而得中也。終凶，訟不可成也。利見大人，尚中正也。不利涉大川，入于淵也。",
        xiang: "【象】：天與水違行，訟。君子以作事謀始。",
        yao1: "【初六】：不永所事，小有言，終吉。",
        yao2: "【九二】：不克訟，歸而逋其邑，人三百戶，无眚。",
        yao3: "【六三】：食舊德，貞厲，終吉，或從王事，无成。",
        yao4: "【九四】：不克訟，復即命渝，安貞吉。",
        yao5: "【九五】：訟，元吉。",
        yao6: "【上九】：或錫之鞶帶，終朝三褫之。",
        yaoXiang1: "【象】：不永所事，訟不可長也。雖小有言，其辯明也。",
        yaoXiang2: "【象】：不克訟，歸逋，竄也。自下訟上，患至掇也。",
        yaoXiang3: "【象】：食舊德，從上吉也。",
        yaoXiang4: "【象】：復即命渝，安貞不失也。",
        yaoXiang5: "【象】：訟元吉，以中正也。",
        yaoXiang6: "【象】：以訟受服，亦不足敬也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "7",
        code : "010000",
        book : "上經", 
        name: "師",
        fullName: "地水師",
        gua: "【卦辭】：師貞，丈人吉，无咎。",
        tuan: "【彖】：師眾也，貞正也，能以眾正，可以王矣。剛中而應，行險而順，以此毒天下，而民從之，吉又何咎矣。",
        xiang: "【象】：地中有水，師，君子以容民畜眾。",
        yao1: "【初六】：師出以律，否臧凶。",
        yao2: "【九二】：在師中吉，无咎，王三錫命。",
        yao3: "【六三】：師或輿尸，凶。",
        yao4: "【六四】：師左次，无咎。",
        yao5: "【六五】：田有禽，利執言，无咎。長子帥師，弟子輿尸，貞凶。",
        yao6: "【上六】：大君有命，開國承家，小人勿用。",
        yaoXiang1: "【象】：師出以律，失律凶也。",
        yaoXiang2: "【象】：在師中吉，承天寵也；王三錫命，懷萬邦也。",
        yaoXiang3: "【象】：師或輿尸，大无功也。",
        yaoXiang4: "【象】：左次无咎，未失常也。",
        yaoXiang5: "【象】：長子帥師，以中行也；弟子輿尸，使不當也。",
        yaoXiang6: "【象】：大君有命，以正功也；小人勿用，必亂邦也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "8",
        code : "000010",
        book : "上經", 
        name: "比",
        fullName: "水地比",
        gua: "【卦辭】：比，吉，原筮，元永貞，无咎。不寧方來，後夫凶。",
        tuan: "【彖】：比，吉也。比，輔也，下順從也。原筮元永貞，无咎，以剛中也。不寧方來，上下應也。後夫凶，其道窮也。",
        xiang: "【象】：地上有水，比。先王以建萬國，親諸侯。",
        yao1: "【初六】：有孚，比之无咎。有孚盈缶，終來，有它吉。",
        yao2: "【六二】：比之自內，貞吉。",
        yao3: "【六三】：比之匪人。",
        yao4: "【六四】：外比之，貞吉。",
        yao5: "【九五】：顯比，王用三驅，失前禽，邑人不誡，吉。",
        yao6: "【上六】：比之无首，凶。",
        yaoXiang1: "【象】：比之初六】：有它吉也。",
        yaoXiang2: "【象】：比之自內，不自失也。",
        yaoXiang3: "【象】：比之匪人，不亦傷乎。",
        yaoXiang4: "【象】：外比於賢，以從上也。",
        yaoXiang5: "【象】：顯比之吉，位正中也；舍逆取順，失前禽也；邑人不誡，上使中也。",
        yaoXiang6: "【象】：比之无首，无所終也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "9",
        code : "111011",
        book : "上經", 
        name: "小畜",
        fullName: "風天小畜",
        gua: "【卦辭】：小畜，亨。密雲不雨，自我西郊。",
        tuan: "【彖】：小畜，柔得位而上下應之，曰小畜。健而巽，剛中而志行，乃亨。密雲不雨，尚往也；自我西郊，施未行也。",
        xiang: "【象】：風行天上，小畜，君子以懿文德。",
        yao1: "【初九】：復自道，何其咎，吉。",
        yao2: "【九二】：牽復，吉。",
        yao3: "【九三】：輿說輻，夫妻反目。",
        yao4: "【六四】：有孚，血去惕出，无咎。",
        yao5: "【九五】：有孚攣如，富以其鄰。",
        yao6: "【上九】：既雨既處，尚德載，婦貞厲。月幾望，君子征凶。",
        yaoXiang1: "【象】：復自道，其義吉也。",
        yaoXiang2: "【象】：牽復在中，亦不自失也。",
        yaoXiang3: "【象】：夫妻反目，不能正室也。",
        yaoXiang4: "【象】：有孚惕出，上合志也。",
        yaoXiang5: "【象】：有孚攣如，不獨富也。",
        yaoXiang6: "【象】：既雨既處，德積載也；君子征凶，有所疑也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "10",
        code : "110111",
        book : "上經", 
        name: "履",
        fullName: "天澤履",
        gua: "【卦辭】：履虎尾，不咥人，亨。",
        tuan: "【彖】：履，柔履剛也。說而應乎乾，是以履虎尾，不咥人，亨。剛中正，履帝位而不疚，光明也。",
        xiang: "【象】：上天下澤，履，君子以辯上下，定民志。",
        yao1: "【初九】：素履，往无咎。",
        yao2: "【九二】：履道坦坦，幽人貞吉。",
        yao3: "【六三】：眇能視，跛能履，履虎尾，咥人凶。武人為于大君。",
        yao4: "【九四】：履虎尾，愬愬，終吉。",
        yao5: "【九五】：夬履，貞厲。",
        yao6: "【上九】：視履，考祥其旋，元吉。",
        yaoXiang1: "【象】：素履之往，獨行願也。",
        yaoXiang2: "象】：幽人貞吉，中不自亂也。",
        yaoXiang3: "【象】：眇能視，不足以有明也；跛能履，不足以與行也；咥人之凶，位不當也；武人為于大君，志剛也。",
        yaoXiang4: "【象】：愬愬終吉，志行也。",
        yaoXiang5: "【象】：夬履貞厲，位正當也。",
        yaoXiang6: "【象】：元吉在上，大有慶也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "11",
        code : "111000",
        book : "上經", 
        name: "泰",
        fullName: "地天泰",
        gua: "【卦辭】：泰，小往大來，吉亨。",
        tuan: "【彖】：泰，小往大來，吉亨，則是天地交而萬物通也，上下交而其志同也。內陽而外陰，內健而外順，內君子而外小人。君子道長，小人道消也。",
        xiang: "【象】：天地交，泰。后以財成天地之道，輔相天地之宜，以左右民。",
        yao1: "【初九】：拔茅茹，以其彙，征吉。",
        yao2: "【九二】：包荒，用馮河，不遐遺，朋亡，得尚于中行。",
        yao3: "【九三】：无平不陂，无往不復。艱貞无咎。勿恤其孚，于食有福。",
        yao4: "【六四】：翩翩不富以其鄰，不戒以孚。",
        yao5: "【六五】：帝乙歸妹，以祉元吉。",
        yao6: "【上六】：城復于隍，勿用師。自邑告命，貞吝。",
        yaoXiang1: "【象】：拔茅征吉，志在外也。",
        yaoXiang2: "【象】：包荒，得尚于中行，以光大也。",
        yaoXiang3: "【象】：无往不復，天地際也。",
        yaoXiang4: "【象】：翩翩不富，皆失實也；不戒以孚，中心願也。",
        yaoXiang5: "【象】：以祉元吉，中以行願也。",
        yaoXiang6: "【象】：城復于隍，其命亂也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "12",
        code : "000111",
        book : "上經", 
        name: "否",
        fullName: "天地否",
        gua: "【卦辭】：否之匪人，不利君子貞，大往小來。",
        tuan: "【彖】：否之匪人，不利君子貞，大往小來，則是天地不交而萬物不通也，上下不交而天下无邦也。內陰而外陽，內柔而外剛，內小人而外君子，小人道長，君子道消也。",
        xiang: "【象】：天地不交，否。君子以儉德辟難，不可榮以祿。",
        yao1: "【初六】：拔茅茹，以其彙，貞吉，亨。",
        yao2: "【六二】：包承，小人吉，大人否亨。",
        yao3: "【六三】：包羞。",
        yao4: "【九四】：有命无咎，疇離祉。",
        yao5: "【九五】：休否，大人吉。其亡其亡，繫于苞桑。",
        yao6: "【上九】：傾否，先否後喜。",
        yaoXiang1: "【象】：拔茅貞吉，志在君也。",
        yaoXiang2: "【象】：大人否亨，不亂群也。",
        yaoXiang3: "【象】：包羞，位不當也。",
        yaoXiang4: "【象】：有命无咎，志行也。",
        yaoXiang5: "【象】：大人之吉，位正當也。",
        yaoXiang6: "【象】：否終則傾，何可長也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "13",
        code : "101111",
        book : "上經", 
        name: "同人",
        fullName: "天火同人",
        gua: "【卦辭】：同人于野，亨。利涉大川，利君子貞。",
        tuan: "【彖】：同人，柔得位得中而應乎乾，曰同人。同人曰，同人于野，亨，利涉大川，乾行也。文明以健，中正而應，君子正也，唯君子為能通天下之志。",
        xiang: "【象】：天與火，同人。君子以類族辨物。",
        yao1: "【初九】：同人于門，无咎。",
        yao2: "【六二】：同人于宗，吝。",
        yao3: "【九三】：伏戎于莽，升其高陵，三歲不興。",
        yao4: "【九四】：乘其墉，弗克攻，吉。",
        yao5: "【九五】：同人，先號咷而後笑，大師克相遇。",
        yao6: "【上九】：同人于郊，无悔。",
        yaoXiang1: "【象】：出門同人，又誰咎也。",
        yaoXiang2: "【象】：同人于宗，吝道也。",
        yaoXiang3: "【象】：伏戎于莽，敵剛也；三歲不興，安行也。",
        yaoXiang4: "【象】：伏戎于莽，敵剛也；三歲不興，安行也。",
        yaoXiang5: "【象】：同人之先，以中直也；大師相遇，言相克也。",
        yaoXiang6: "【象】：同人于郊，志未得也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "14",
        code : "111101",
        book : "上經", 
        name: "大有",
        fullName: "火天大有",
        gua: "【卦辭】：大有，元亨。",
        tuan: "【彖】：大有，柔得尊位大中，而上下應之，曰大有。其德剛健而文明，應乎天而時行，是以元亨。",
        xiang: "【象】：火在天上，大有。君子以遏惡揚善，順天休命。",
        yao1: "【初九】：无交害，匪咎，艱則无咎。",
        yao2: "【九二】：大車以載，有攸往，无咎。",
        yao3: "【九三】：公用亨于天子，小人弗克。",
        yao4: "【九四】：匪其彭，无咎。",
        yao5: "【六五】：厥孚交如，威如，吉。",
        yao6: "【上九】：自天祐之，吉无不利。",
        yaoXiang1: "【象】：大有初九，无交害也。",
        yaoXiang2: "【象】：大車以載，積中不敗也。",
        yaoXiang3: "【象】：公用亨于天子，小人害也。",
        yaoXiang4: "【象】：匪其彭，无咎，明辨皙也。",
        yaoXiang5: "【象】：厥孚交如，信以發志也。威如之吉，易而无備也。",
        yaoXiang6: "【象】：大有上吉，自天祐也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "15",
        code : "001000",
        book : "上經", 
        name: "謙",
        fullName: "地山謙",
        gua: "【卦辭】：謙，亨，君子有終。",
        tuan: "【彖】：謙亨，天道下濟而光明，地道卑而上行；天道虧盈而益謙，地道變盈而流謙；鬼神害盈而福謙，人道惡盈而好謙。謙尊而光，卑而不可踰，君子之終也。",
        xiang: "【象】：地中有山，謙，君子以裒多益寡，稱物平施。",
        yao1: "【初六】：謙謙君子，用涉大川，吉。",
        yao2: "【六二】：鳴謙，貞吉。",
        yao3: "【九三】：勞謙，君子有終，吉。",
        yao4: "【六四】：无不利，撝謙。",
        yao5: "【六五】：不富以其鄰，利用侵伐，无不利。",
        yao6: "【上六】：鳴謙，利用行師，征邑國。",
        yaoXiang1: "【象】：謙謙君子，卑以自牧也。",
        yaoXiang2: "【象】：鳴謙貞吉，中心得也。",
        yaoXiang3: "【象】：勞謙君子，萬民服也。",
        yaoXiang4: "【象】：无不利，撝謙，不違則也。",
        yaoXiang5: "【象】：利用侵伐，征不服也。",
        yaoXiang6: "【象】：鳴謙，志未得也，可用行師，征邑國也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "16",
        code : "000100",
        book : "上經", 
        name: "豫",
        fullName: "雷地豫",
        gua: "【卦辭】：豫，利建侯、行師。",
        tuan: "【彖】：豫，剛應而志行，順以動，豫。豫順以動，故天地如之，而況建侯行師乎？天地以順動，故日月不過，而四時不忒。聖人以順動，則刑罰清而民服。豫之時義大矣哉。",
        xiang: "【象】：雷出地奮，豫。先王以作樂崇德，殷薦之上帝，以配祖考。",
        yao1: "【初六】：鳴豫，凶。",
        yao2: "【六二】：介于石，不終日，貞吉。",
        yao3: "【六三】：盱豫，悔遲有悔。",
        yao4: "【九四】：由豫，大有得。勿疑，朋盍簪。",
        yao5: "【六五】：貞疾，恒不死。",
        yao6: "【上六】：冥豫，成有渝，无咎。",
        yaoXiang1: "【象】：初六鳴豫，志窮凶也。",
        yaoXiang2: "【象】：不終日，貞吉，以中正也。",
        yaoXiang3: "【象】：盱豫有悔，位不當也。",
        yaoXiang4: "【象】：由豫，大有得，志大行也。",
        yaoXiang5: "【象】：六五】：貞疾，乘剛也。恒不死，中未亡也。",
        yaoXiang6: "【象】：冥豫在上，何可長也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "17",
        code : "100110",
        book : "上經", 
        name: "隨",
        fullName: "澤雷隨",
        gua: "【卦辭】：隨，元亨利貞，无咎。",
        tuan: "【彖】：隨，剛來而下柔，動而說，隨。大亨貞，无咎，而天下隨時，隨時之義大矣哉。",
        xiang: "【象】：澤中有雷，隨。君子以嚮晦入宴息。",
        yao1: "【初九】：官有渝，貞吉。出門交有功。",
        yao2: "【六二】：係小子，失丈夫。",
        yao3: "【六三】：係丈夫，失小子。隨有求得，利居貞。",
        yao4: "【九四】：隨有獲，貞凶。有孚，在道以明，何咎？",
        yao5: "【九五】：孚于嘉，吉。",
        yao6: "【上六】：拘係之，乃從維之，王用亨于西山。",
        yaoXiang1: "【象】：官有渝，從正吉也；出門交有功，不失也。",
        yaoXiang2: "【象】：係小子，弗兼與也。",
        yaoXiang3: "【象】：係丈夫，志舍下也。",
        yaoXiang4: "【象】：隨有獲，其義凶也；有孚在道，明功也。",
        yaoXiang5: "【象】：孚于嘉吉，位正中也。",
        yaoXiang6: "【象】：拘係之。上窮也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "18",
        code : "011001",
        book : "上經", 
        name: "蠱",
        fullName: "山風蠱",
        gua: "【卦辭】：蠱，元亨，利涉大川。先甲三日，後甲三日。",
        tuan: "【彖】：蠱，剛上而柔下，巽而止，蠱。蠱元亨，而天下治也；利涉大川，往有事也；先甲三日，後甲三日，終則有始，天行也。",
        xiang: "【象】：山下有風，蠱。君子以振民育德。",
        yao1: "【初六】：幹父之蠱，有子，考无咎，厲終吉。",
        yao2: "【九二】：幹母之蠱，不可貞。",
        yao3: "【九三】：幹父之蠱，小有悔，无大咎。",
        yao4: "【六四】：裕父之蠱，往見吝。",
        yao5: "【六五】：幹父之蠱，用譽。",
        yao6: "【上九】：不事王侯，高尚其事。",
        yaoXiang1: "【象】：幹父之蠱，意承考也。",
        yaoXiang2: "【象】：幹母之蠱，得中道也。",
        yaoXiang3: "【象】：幹父之蠱，終无咎也。",
        yaoXiang4: "【象】：裕父之蠱，往未得也。",
        yaoXiang5: "【象】：幹父用譽，承以德也。",
        yaoXiang6: "【象】：不事王侯，志可則也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "19",
        code : "110000",
        book : "上經", 
        name: "臨",
        fullName: "地澤臨",
        gua: "【卦辭】：臨，元亨利貞，至于八月有凶。",
        tuan: "【彖】：臨，剛浸而長，說而順，剛中而應，大亨以正，天之道也；至于八月有凶，消不久也。",
        xiang: "【象】：澤上有地，臨。君子以教思无窮，容保民无疆。",
        yao1: "【初九】：咸臨，貞吉。",
        yao2: "【九二】：咸臨，吉，无不利。",
        yao3: "【六三】：甘臨，无攸利。既憂之，无咎。",
        yao4: "【六四】：至臨，无咎。",
        yao5: "【六五】：知臨，大君之宜，吉。",
        yao6: "【上六】：敦臨，吉，无咎。",
        yaoXiang1: "【象】：咸臨貞吉，志行正也。",
        yaoXiang2: "【象】：咸臨吉无不利，未順命也。",
        yaoXiang3: "【象】：甘臨，位不當也，既憂之，咎不長也。",
        yaoXiang4: "【象】：至臨无咎，位當也。",
        yaoXiang5: "【象】：大君之宜，行中之謂也。",
        yaoXiang6: "【象】：敦臨之吉，志在內也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "20",
        code : "000011",
        book : "上經", 
        name: "觀",
        fullName: "風地觀",
        gua: "【卦辭】：觀，盥而不薦，有孚顒若。",
        tuan: "【彖】：大觀在上，順而巽，中正以觀天下。觀盥而不薦，有孚顒若，下觀而化也。觀天之神道，而四時不忒，聖人以神道設教，而天下服矣。",
        xiang: "【象】：風行地上，觀，先王以省方，觀民設教。",
        yao1: "【初六】：童觀，小人无咎，君子吝。",
        yao2: "【六二】：闚觀，利女貞。",
        yao3: "【六三】：觀我生，進退。",
        yao4: "【六四】：觀國之光，利用賓于王。",
        yao5: "【九五】：觀我生，君子无咎。",
        yao6: "【上九】：觀其生，君子无咎。",
        yaoXiang1: "【象】：初六童觀，小人道也。",
        yaoXiang2: "【象】：闚觀女貞，亦可醜也。",
        yaoXiang3: "【象】：觀我生進退，未失道也。",
        yaoXiang4: "【象】：觀國之光，尚賓也。",
        yaoXiang5: "【象】：觀我生，觀民也。",
        yaoXiang6: "【象】：觀其生，志未平也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "21",
        code : "100101",
        book : "上經", 
        name: "噬嗑",
        fullName: "火雷噬嗑",
        gua: "【卦辭】：噬嗑，亨，利用獄。",
        tuan: "【彖】：頤中有物，曰噬嗑。噬嗑而亨，剛柔分動而明，雷電合而章，柔得中而上行，雖不當位，利用獄也。",
        xiang: "【象】：雷電，噬嗑，先王以明罰敕法。",
        yao1: "【初九】：屨校滅趾，无咎。",
        yao2: "【六二】：噬膚，滅鼻，无咎。",
        yao3: "【六三】：噬腊肉，遇毒。小吝无咎。",
        yao4: "【九四】：噬乾胏，得金矢，利艱貞吉。",
        yao5: "【六五】：噬乾肉，得黃金，貞厲无咎。",
        yao6: "【上九】：何校滅耳，凶。",
        yaoXiang1: "【象】：屨校滅趾，不行也。",
        yaoXiang2: "【象】：噬膚滅鼻，乘剛也。",
        yaoXiang3: "【象】：遇毒，位不當也。",
        yaoXiang4: "【象】：利艱貞吉，未光也。",
        yaoXiang5: "【象】：貞厲无咎，得當也。",
        yaoXiang6: "【象】：何校滅耳，聰不明也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "22",
        code : "101001",
        book : "上經", 
        name: "賁卦",
        fullName: "山火賁",
        gua: "【卦辭】：賁亨，小利有攸往。",
        tuan: "【彖】：賁亨。柔來而文剛，故亨。分剛上而文柔，故小利有攸往，天文也。文明以止，人文也。觀乎天文，以察時變，觀乎人文，以化成天下。",
        xiang: "【象】：山下有火，賁。君子以明庶政，无敢折獄。",
        yao1: "【初九】：賁其趾，舍車而徒。",
        yao2: "【六二】：賁其須。",
        yao3: "【九三】：賁如濡如，永貞吉。",
        yao4: "【六四】：賁如皤如，白馬翰如，匪寇婚媾。",
        yao5: "【六五】：賁于丘園，束帛戔戔。吝，終吉。",
        yao6: "【上九】：白賁，无咎。",
        yaoXiang1: "【象】：舍車而徒，義弗乘也。",
        yaoXiang2: "【象】：賁其須，與上興也。",
        yaoXiang3: "【象】：永貞之吉，終莫之陵也。",
        yaoXiang4: "【象】：六四當位，疑也；匪寇婚媾，終无尤也。",
        yaoXiang5: "【象】：六五之吉，有喜也。",
        yaoXiang6: "【象】：白賁无咎，上得志也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "23",
        code : "000001",
        book : "上經", 
        name: "剝卦",
        fullName: "山地剝",
        gua: "【卦辭】：剝，不利有攸往。",
        tuan: "【彖】：剝，剝也，柔變剛也。不利有攸往，小人長也。順而止之，觀象也。君子尚消息盈虛，天行也。",
        xiang: "【象】：山附于地，剝，上以厚下安宅。",
        yao1: "【初六】：剝床以足，蔑貞凶。",
        yao2: "【六二】：剝床以辨，蔑貞凶。",
        yao3: "【六三】：剝之无咎。",
        yao4: "【六四】：剝床以膚，凶。",
        yao5: "【六五】：貫魚以宮人寵，无不利。",
        yao6: "【上九】：碩果不食，君子得輿，小人剝廬。",
        yaoXiang1: "【象】：剝床以足，以滅下也。",
        yaoXiang2: "【象】：剝床以辨，未有與也。",
        yaoXiang3: "【象】：剝之无咎，失上下也。",
        yaoXiang4: "【象】：剝床以膚，切近災也。",
        yaoXiang5: "【象】：以宮人寵，終无尤也。",
        yaoXiang6: "【象】：君子得輿，民所載也，小人剝廬，終不可用也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "24",
        code : "100000",
        book : "上經", 
        name: "復",
        fullName: "地雷復",
        gua: "【卦辭】：復，亨。出入无疾，朋來无咎。反復其道，七日來復，利有攸往。",
        tuan: "【彖】：復，亨。剛反，動而以順行，是以出入无疾，朋來无咎，反復其道，七日來復，天行也。利有攸往，剛長也。復，其見天地之心乎。",
        xiang: "【象】：雷在地中，復，先王以至日閉關，商旅不行，后不省方。",
        yao1: "【初九】：不遠復，无祇悔，元吉。",
        yao2: "【六二】：休復，吉。",
        yao3: "【六三】：頻復，厲，无咎。",
        yao4: "【六四】：中行獨復。",
        yao5: "【六五】：敦復，无悔。",
        yao6: "【上六】：迷復，凶，有災眚，用行師，終有大敗。以其國君，凶。至于十年不克征。",
        yaoXiang1: "【象】：不遠之復，以脩身也。",
        yaoXiang2: "【象】：休復之吉，以下仁也。",
        yaoXiang3: "【象】：頻復之厲，義无咎也。",
        yaoXiang4: "【象】：中行獨復，以從道也。",
        yaoXiang5: "【象】：敦復无悔，中以自考也。",
        yaoXiang6: "【象】：迷復之凶，反君道也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "25",
        code : "100111",
        book : "上經", 
        name: "无妄",
        fullName: "天雷无妄",
        gua: "【卦辭】：无妄，元亨利貞。其匪正有眚，不利有攸往。",
        tuan: "【彖】：无妄，剛自外來而為主於內，動而健，剛中而應，大亨以正，天之命也，其匪正有眚，不利有攸往。无妄之往，何之矣。天命不祐，行矣哉。",
        xiang: "【象】：天下雷行，物與无妄。先王以茂對，時育萬物。",
        yao1: "【初九】：无妄往，吉。",
        yao2: "【六二】：不耕穫，不菑畬，則利有攸往。",
        yao3: "【六三】：无妄之災，或繫之牛，行人之得，邑人之災。",
        yao4: "【九四】：可貞，无咎。",
        yao5: "【九五】：无妄之疾，勿藥有喜。",
        yao6: "【上九】：无妄行，有眚，无攸利。",
        yaoXiang1: "【象】：无妄之往，得志也。",
        yaoXiang2: "【象】：不耕穫，未富也。",
        yaoXiang3: "【象】：行人得牛，邑人災也。",
        yaoXiang4: "【象】：可貞无咎，固有之也。",
        yaoXiang5: "【象】：无妄之藥，不可試也。",
        yaoXiang6: "【象】：无妄之行，窮之災也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "26",
        code : "111001",
        book : "上經", 
        name: "大畜",
        fullName: "山天大畜",
        gua: "【卦辭】：大畜，利貞，不家食吉，利涉大川。",
        tuan: "【彖】：大畜，剛健篤實，輝光日新其德，剛上而尚賢，能止健，大正也。不家食吉，養賢也；利涉大川，應乎天也。",
        xiang: "【象】：天在山中，大畜。君子以多識前言往行，以畜其德。",
        yao1: "【初九】：有厲，利已。",
        yao2: "【九二】：輿說輹。",
        yao3: "【九三】：良馬逐，利艱貞。曰閑輿衛，利有攸往。",
        yao4: "【六四】：童牛之牿，元吉。",
        yao5: "【六五】：豶豕之牙，吉。",
        yao6: "【上九】：何天之衢，亨。",
        yaoXiang1: "【象】：有厲利已，不犯災也。",
        yaoXiang2: "【象】：輿說輹，中无尤也。",
        yaoXiang3: "【象】：利有攸往，上合志也。",
        yaoXiang4: "【象】：六四元吉，有喜也。",
        yaoXiang5: "【象】：六五之吉，有慶也。",
        yaoXiang6: "【象】：何天之衢，道大行也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "27",
        code : "100001",
        book : "上經", 
        name: "頤",
        fullName: "山雷頤",
        gua: "【卦辭】：頤，貞吉，觀頤，自求口實。",
        tuan: "【彖】：頤，貞吉，養正則吉也。觀頤，觀其所養也；自求口實，觀其自養也。天地養萬物，聖人養賢以及萬民，頤之時大矣哉。",
        xiang: "【象】：山下有雷，頤，君子以慎言語，節飲食。",
        yao1: "【初九】：舍爾靈龜，觀我朵頤，凶。",
        yao2: "【六二】：顛頤，拂經。于丘頤，征凶。",
        yao3: "【六三】：拂頤，貞凶。十年勿用，无攸利。",
        yao4: "【六四】：顛頤，吉，虎視眈眈，其欲逐逐，无咎。",
        yao5: "【六五】：拂經，居貞吉，不可涉大川。",
        yao6: "【上九】：由頤，厲吉，利涉大川。",
        yaoXiang1: "【象】：觀我朵頤，亦不足貴也。",
        yaoXiang2: "【象】：六二征凶，行失類也。",
        yaoXiang3: "【象】：十年勿用，道大悖也。",
        yaoXiang4: "【象】：顛頤之吉，上施光也。",
        yaoXiang5: "【象】：居貞之吉，順以從上也。",
        yaoXiang6: "【象】：由頤厲吉，大有慶也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "28",
        code : "011110",
        book : "上經", 
        name: "大過",
        fullName: "澤風大過",
        gua: "【卦辭】：大過，棟橈。利有攸往，亨。",
        tuan: "【彖】：大過，大者過也。棟橈，本末弱也。剛過而中，巽而說行，利有攸往，乃亨，大過之時大矣哉。",
        xiang: "【象】：澤滅木，大過。君子以獨立不懼，遯世无悶。",
        yao1: "【初六】：藉用白茅，无咎。",
        yao2: "【九二】：枯楊生稊，老夫得其女妻，无不利。",
        yao3: "【九三】：棟橈，凶。",
        yao4: "【九四】：棟隆，吉，有它吝。",
        yao5: "【九五】：枯楊生華，老婦得其士夫，无咎无譽。",
        yao6: "【上六】：過涉滅頂，凶，无咎。",
        yaoXiang1: "【象】：藉用白茅，柔在下也。",
        yaoXiang2: "【象】：老夫女妻，過以相與也。",
        yaoXiang3: "【象】：棟橈之凶，不可以有輔也。",
        yaoXiang4: "【象】：棟隆之吉，不橈乎下也。",
        yaoXiang5: "【象】：枯楊生華，何可久也；老婦士夫，亦可醜也。",
        yaoXiang6: "【象】：過涉之凶，不可咎也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "29",
        code : "010010",
        book : "上經", 
        name: "坎",
        fullName: "坎為水",
        gua: "【卦辭】：習坎，有孚，維心亨，行有尚。",
        tuan: "【彖】：習坎，重險也。水流而不盈，行險而不失其信。維心亨，乃以剛中也；行有尚，往有功也。天險不可升也，地險山川丘陵也，王公設險以守其國，險之時用大矣哉。",
        xiang: "【象】：水洊至，習坎。君子以常德行，習教事。",
        yao1: "【初六】：習坎，入于坎窞，凶。",
        yao2: "【九二】：坎，有險，求小得。",
        yao3: "【六三】：來之坎坎，險且枕，入于坎窞，勿用。",
        yao4: "【六四】：樽酒，簋貳，用缶，納約自牖，終无咎。",
        yao5: "【九五】：坎不盈，祗既平，无咎。",
        yao6: "【上六】：係用黴纆，寘于叢棘，三歲不得，凶。",
        yaoXiang1: "【象】：習坎入坎，失道凶也。",
        yaoXiang2: "【象】：求小得，未出中也。",
        yaoXiang3: "【象】：來之坎坎，終无功也。",
        yaoXiang4: "【象】：樽酒簋貳，剛柔際也。",
        yaoXiang5: "【象】：坎不盈，中未大也。",
        yaoXiang6: "【象】：上六失道，凶三歲也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "30",
        code : "101101",
        book : "上經", 
        name: "離",
        fullName: "離為火",
        gua: "【卦辭】：離，利貞，亨，畜牝牛，吉。",
        tuan: "【彖】：離，麗也。日月麗乎天，百穀草木麗乎土，重明以麗乎正，乃化成天下。柔麗乎中正，故亨，是以畜牝牛吉也。",
        xiang: "【象】：明兩作，離，大人以繼明照于四方。",
        yao1: "【初九】：履錯然，敬之，无咎。",
        yao2: "【六二】：黃離，元吉。",
        yao3: "【九三】：日昃之離，不鼓缶而歌，則大耋之嗟，凶。",
        yao4: "【九四】：突如其來如，焚如，死如，棄如。",
        yao5: "【六五】：出涕沱若，戚嗟若，吉。",
        yao6: "【上九】：王用出征，有嘉折首，獲匪其醜，无咎。",
        yaoXiang1: "【象】：履錯之敬，以辟咎也。",
        yaoXiang2: "【象】：黃離元吉，得中道也。",
        yaoXiang3: "【象】：日昃之離，何可久也。",
        yaoXiang4: "【象】：突如其來如，无所容也。",
        yaoXiang5: "【象】：六五之吉，離王公也。",
        yaoXiang6: "【象】：王用出征，以正邦也。",
        yong9: "",
        yong6: ""
    }
]

export const guabook2 = [
    {
        id : "31",
        code : "001110",
        book : "下經", 
        name: "咸",
        fullName: "澤山咸",
        gua: "【卦辭】：咸亨，利貞，取女吉。",
        tuan: "【彖】：咸，感也。柔上而剛下，二氣感應以相與，止而說，男下女，是以亨，利貞，取女吉也。天地感而萬物化生，聖人感人心而天下和平。觀其所感，而天地萬物之情可見矣。",
        xiang: "【象】：山上有澤，咸，君子以虛受人。",
        yao1: "【初六】：咸其拇。",
        yao2: "【六二】：咸其腓，凶，居吉。",
        yao3: "【九三】：咸其股，執其隨，往吝。",
        yao4: "【九四】：貞吉，悔亡，憧憧往來，朋從爾思。",
        yao5: "【九五】：咸其脢，无悔。",
        yao6: "【上六】：咸其輔頰舌。",
        yaoXiang1: "【象】：咸其拇，志在外也。",
        yaoXiang2: "【象】：雖凶居吉，順不害也。",
        yaoXiang3: "【象】：咸其股，亦不處也。志在隨人，所執下也。",
        yaoXiang4: "【象】：貞吉悔亡，未感害也；憧憧往來，未光大也。",
        yaoXiang5: "【象】：咸其脢，志末也。",
        yaoXiang6: "【象】：咸其輔頰舌，滕口說也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "32",
        code : "011100",
        book : "下經", 
        name: "恒",
        fullName: "雷風恒",
        gua: "【卦辭】：恒，亨，无咎，利貞，利有攸往。",
        tuan: "【彖】：恒，久也。剛上而柔下，雷風相與，巽而動，剛柔皆應，恒。恒，亨，无咎，利貞，久於其道也。天地之道，恒久而不已也，利有攸往，終則有始也，日月得天而能久照，四時變化而能久成，聖人久於其道而天下化成，觀其所恒而天地萬物之情可見矣。",
        xiang: "【象】：雷風，恒，君子以立不易方。",
        yao1: "【初六】：浚恒，貞凶，无攸利。",
        yao2: "【九二】：悔亡。",
        yao3: "【九三】：不恒其德，或承之羞，貞吝。",
        yao4: "【九四】：田无禽。",
        yao5: "【六五】：恒其德貞，婦人吉，夫子凶。",
        yao6: "【上六】：振恒，凶。",
        yaoXiang1: "【象】：浚恒之凶，始求深也。",
        yaoXiang2: "【象】：九二悔亡，能久中也。",
        yaoXiang3: "【【象】：不恒其德，无所容也。",
        yaoXiang4: "【象】：久非其位，安得禽也。",
        yaoXiang5: "【象】：婦人貞吉，從一而終也。夫子制義，從婦凶也。",
        yaoXiang6: "【象】：振恒在上，大无功也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "33",
        code : "001111",
        book : "下經", 
        name: "遯",
        fullName: "天山遯",
        gua: "【卦辭】：遯亨，小利貞。",
        tuan: "【彖】：遯亨，遯而亨也。剛當位而應，與時行也。小利貞，浸而長也。遯之時義大矣哉。",
        xiang: "【象】：天下有山，遯。君子以遠小人，不惡而嚴。",
        yao1: "【初六】：遯尾，厲。勿用有攸往。",
        yao2: "【六二】：執之用黃牛之革，莫之勝說。",
        yao3: "【九三】：係遯，有疾厲，畜臣妾吉。",
        yao4: "【九四】：好遯，君子吉，小人否。",
        yao5: "【九五】：嘉遯，貞吉。",
        yao6: "【上九】：肥遯，无不利。",
        yaoXiang1: "【象】：遯尾之厲，不往何災也。",
        yaoXiang2: "【象】：執用黃牛，固志也。",
        yaoXiang3: "【象】：係遯之厲，有疾憊也。畜臣妾吉，不可大事也。",
        yaoXiang4: "【象】：君子好遯，小人否也。",
        yaoXiang5: "【象】：嘉遯貞吉，以正志也。",
        yaoXiang6: "【象】：肥遯，无不利，无所疑也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "34",
        code : "111100",
        book : "下經", 
        name: "大壯",
        fullName: "雷天大壯",
        gua: "【卦辭】：大壯，利貞。",
        tuan: "【彖】：大壯，大者壯也，剛以動，故壯。大壯利貞，大者正也。正大而天地之情可見矣。",
        xiang: "【象】：雷在天上，大壯，君子以非禮弗履。",
        yao1: "【初九】：壯于趾，征凶，有孚。",
        yao2: "【九二】：貞吉。",
        yao3: "【九三】：小人用壯，君子用罔。貞厲，羝羊觸藩，羸其角。",
        yao4: "【九四】：貞吉，悔亡，藩決不羸，壯于大輿之輹。",
        yao5: "【六五】：喪羊于易，无悔。",
        yao6: "【上六】：羝羊觸藩，不能退，不能遂，无攸利，艱則吉。",
        yaoXiang1: "【象】：壯于趾，其孚窮也。",
        yaoXiang2: "【象】：九二貞吉，以中也。",
        yaoXiang3: "【象】：小人用壯，君子罔也。",
        yaoXiang4: "【象】：藩決不羸，尚往也。",
        yaoXiang5: "【象】：喪羊于易，位不當也。",
        yaoXiang6: "【象】：不能退，不能遂，不詳也。艱則吉，咎不長也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "35",
        code : "000101",
        book : "下經", 
        name: "晉",
        fullName: "火地晉",
        gua: "【卦辭】：晉，康侯用錫馬蕃庶，晝日三接。",
        tuan: "【彖】：晉，進也。明出地上，順而麗乎大明，柔進而上行，是以康侯用錫馬蕃庶，晝日三接也。",
        xiang: "【象】：明出地上，晉。君子以自昭明德。",
        yao1: "【初六】：晉如摧如，貞吉。罔孚裕，无咎。",
        yao2: "【六二】：晉如愁如，貞吉。受茲介福，于其王母。",
        yao3: "【六三】：眾允，悔亡。",
        yao4: "【九四】：晉如鼫鼠，貞厲。",
        yao5: "【六五】：悔亡，失得勿恤。往吉无不利。",
        yao6: "【上九】：晉其角，維用伐邑。厲吉无咎，貞吝。",
        yaoXiang1: "【象】：晉如摧如，獨行正也；裕无咎，未受命也。",
        yaoXiang2: "【象】：受茲介福，以中正也。",
        yaoXiang3: "【象】：眾允之，志上行也。",
        yaoXiang4: "【象】：鼫鼠貞厲，位不當也。",
        yaoXiang5: "【象】：失得勿恤，往有慶也。",
        yaoXiang6: "【象】：維用伐邑，道未光也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "36",
        code : "101000",
        book : "下經", 
        name: "明夷",
        fullName: "地火明夷",
        gua: "【卦辭】：明夷，利艱貞。",
        tuan: "【彖】：明入地中，明夷。內文明而外柔順，以蒙大難，文王以之。利艱貞，晦其明也。內難而能正其志，箕子以之。",
        xiang: "【象】：明入地中，明夷。君子以莅眾，用晦而明。",
        yao1: "【初九】：明夷于飛，垂其翼。君子于行，三日不食。有攸往，主人有言。",
        yao2: "【六二】：明夷，夷于左股，用拯馬壯吉。",
        yao3: "【九三】：明夷于南狩，得其大首，不可疾貞。",
        yao4: "【六四】：入于左腹，獲明夷之心，于出門庭。",
        yao5: "【六五】：箕子之明夷，利貞。",
        yao6: "【上六】：不明晦，初登于天，後入于地。",
        yaoXiang1: "【象】：君子于行，義不食也。",
        yaoXiang2: "【象】：六二之吉，順以則也。",
        yaoXiang3: "【象】：南狩之志，乃得大也。",
        yaoXiang4: "【象】：入于左腹，獲心意也。",
        yaoXiang5: "【象】：箕子之貞，明不可息也。",
        yaoXiang6: "【象】：初登于天，照四國也；後入于地，失則也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "37",
        code : "101011",
        book : "下經", 
        name: "家人",
        fullName: "風火家人",
        gua: "【卦辭】：家人，利女貞。",
        tuan: "【彖】：家人，女正位乎內，男正位乎外，男女正，天地之大義也。家人有嚴君焉，父母之謂也。父父，子子，兄兄，弟弟，夫夫，婦婦，而家道正。正家，而天下定矣。",
        xiang: "【象】：風自火出，家人，君子以言有物，而行有恆。",
        yao1: "【初九】：閑有家，悔亡。",
        yao2: "【六二】：无攸遂，在中饋，貞吉。",
        yao3: "【九三】：家人嗃嗃，悔厲吉，婦子嘻嘻，終吝。",
        yao4: "【六四】：富家，大吉。",
        yao5: "【九五】：王假有家，勿恤，吉。",
        yao6: "【上九】：有孚，威如，終吉。",
        yaoXiang1: "【象】：閑有家，志未變也。",
        yaoXiang2: "【象】：六二之吉，順以巽也。",
        yaoXiang3: "【象】：家人嗃嗃，未失也。婦子嘻嘻，失家節也。",
        yaoXiang4: "【象】：富家大吉，順在位也。",
        yaoXiang5: "【象】：王假有家，交相愛也。",
        yaoXiang6: "【象】：威如之吉，反身之謂也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "38",
        code : "110101",
        book : "下經", 
        name: "睽",
        fullName: "火澤睽",
        gua: "【卦辭】：睽，小事吉。",
        tuan: "【彖】：睽，火動而上，澤動而下，二女同居，其志不同行。說而麗乎明，柔進而上行，得中而應乎剛，是以小事吉。天地睽而其事同也，男女睽而其志通也，萬物睽而其事類也，睽之時用大矣哉。",
        xiang: "【象】：上火下澤，睽，君子以同而異。",
        yao1: "【初九】：悔亡，喪馬勿逐，自復。見惡人，无咎。",
        yao2: "【九二】：遇主于巷，无咎。",
        yao3: "【六三】：見輿曳，其牛掣，其人天且劓，无初有終。",
        yao4: "【九四】：睽孤，遇元夫。交孚，厲无咎。",
        yao5: "【六五】：悔亡。厥宗噬膚，往何咎。",
        yao6: "【上九】：睽孤，見豕負塗，載鬼一車，先張之弧，後說之弧，匪寇婚媾。往，遇雨則吉。",
        yaoXiang1: "【象】：見惡人，以辟咎也。",
        yaoXiang2: "【象】：遇主于巷，未失道也。",
        yaoXiang3: "【象】：見輿曳，位不當也。无初有終，遇剛也。",
        yaoXiang4: "【象】：交孚无咎，志行也。",
        yaoXiang5: "【象】：厥宗噬膚，往有慶也。",
        yaoXiang6: "【象】：遇雨之吉，群疑亡也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "39",
        code : "001010",
        book : "下經", 
        name: "蹇",
        fullName: "水山蹇",
        gua: "【卦辭】：蹇，利西南，不利東北，利見大人，貞吉。",
        tuan: "【彖】：蹇，難也，險在前也。見險而能止，知矣哉。蹇，利西南，往得中也；不利東北，其道窮也。利見大人，往有功也；當位貞吉，以正邦也。蹇之時用大矣哉。",
        xiang: "【象】：山上有水，蹇，君子以反身脩德。",
        yao1: "【初六】：往蹇來譽。",
        yao2: "【六二】：王臣蹇蹇，匪躬之故。",
        yao3: "【九三】：往蹇來反。",
        yao4: "【六四】：往蹇來連。",
        yao5: "【九五】：大蹇朋來。",
        yao6: "【上六】：往蹇來碩，吉，利見大人。",
        yaoXiang1: "【象】：往蹇來譽，宜待也。",
        yaoXiang2: "【象】：王臣蹇蹇，終无尤也。",
        yaoXiang3: "【象】：往蹇來反，內喜之也。",
        yaoXiang4: "【象】：往蹇來連，當位實也。",
        yaoXiang5: "【象】：大蹇朋來，以中節也。",
        yaoXiang6: "【象】：往蹇來碩，志在內也；利見大人，以從貴也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "40",
        code : "010100",
        book : "下經", 
        name: "解",
        fullName: "雷水解",
        gua: "【卦辭】：解，利西南，无所往，其來復吉；有攸往，夙吉。",
        tuan: "【彖】：解，險以動，動而免乎險，解。解，利西南，往得眾也；其來復吉，乃得中也；有攸往夙吉，往有功也。天地解而雷雨作，雷雨作而百果草木皆甲坼，解之時大矣哉。",
        xiang: "【象】：雷雨作，解。君子以赦過宥罪。",
        yao1: "【初六】：无咎。",
        yao2: "【九二】：田獲三狐，得黃矢，貞吉。",
        yao3: "【六三】：負且乘，致寇至，貞吝。",
        yao4: "【九四】：解而拇，朋至斯孚。",
        yao5: "【六五】：君子維有解，吉，有孚于小人。",
        yao6: "【上六】：公用射隼于高墉之上，獲之，无不利。",
        yaoXiang1: "【象】：剛柔之際，義无咎也。",
        yaoXiang2: "【象】：九二貞吉，得中道也。",
        yaoXiang3: "【象】：負且乘，亦可醜也，自我致戎，又誰咎也。",
        yaoXiang4: "【象】：解而拇，未當位也。",
        yaoXiang5: "【象】：君子有解，小人退也。",
        yaoXiang6: "【象】：公用射隼，以解悖也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "41",
        code : "110001",
        book : "下經", 
        name: "損",
        fullName: "山澤損",
        gua: "【卦辭】：損，有孚，元吉，无咎可貞，利有攸往。曷之用，二簋可用享。",
        tuan: "【彖】：損，損下益上，其道上行，損而有孚，元吉。无咎，可貞，利有攸往，曷之用，二簋可用享，二簋應有時，損剛益柔有時，損益盈虛，與時偕行。",
        xiang: "【象】：山下有澤，損，君子以懲忿窒欲。",
        yao1: "【初九】：已事遄往，无咎，酌損之。",
        yao2: "【九二】：利貞，征凶。弗損，益之。",
        yao3: "【六三】：三人行，則損一人，一人行，則得其友。",
        yao4: "【六四】：損其疾，使遄有喜，无咎。",
        yao5: "【六五】：或益之十朋之龜，弗克違，元吉。",
        yao6: "【上九】：弗損，益之，无咎，貞吉，利有攸往，得臣无家。",
        yaoXiang1: "【象】：已事遄往，尚合志也。",
        yaoXiang2: "【象】：九二利貞，中以為志也。",
        yaoXiang3: "【象】：一人行，三則疑也。",
        yaoXiang4: "【象】：損其疾，亦可喜也。",
        yaoXiang5: "【象】：六五元吉，自上祐也。",
        yaoXiang6: "【象】：弗損益之，大得志也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "42",
        code : "100011",
        book : "下經", 
        name: "益",
        fullName: "風雷益",
        gua: "【卦辭】：益，利有攸往，利涉大川。",
        tuan: "【彖】：益，損上益下，民說无疆，自上下下，其道大光。利有攸往，中正有慶；利涉大川，木道乃行。益動而巽，日進无疆，天施地生，其益无方，凡益之道，與時偕行。",
        xiang: "【象】：風雷，益，君子以見善則遷，有過則改。",
        yao1: "【初九】：利用為大作，元吉，无咎。",
        yao2: "【六二】：或益之十朋之龜，弗克違，永貞吉。王用享于帝，吉。",
        yao3: "【六三】：益之用凶事，无咎。有孚中行，告公用圭。",
        yao4: "【六四】：中行，告公從，利用為依遷國。",
        yao5: "【九五】：有孚惠心，勿問元吉。有孚惠我德。",
        yao6: "【上九】：莫益之，或擊之，立心勿恒，凶。",
        yaoXiang1: "【象】：元吉无咎，下不厚事也。",
        yaoXiang2: "【象】：或益之，自外來也。",
        yaoXiang3: "【象】：益用凶事，固有之也。",
        yaoXiang4: "【象】：告公從，以益志也。",
        yaoXiang5: "【象】：有孚惠心，勿問之矣；惠我德，大得志也。",
        yaoXiang6: "【象】：莫益之，偏辭也；或擊之，自外來也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "43",
        code : "111110",
        book : "下經", 
        name: "夬",
        fullName: "澤天夬",
        gua: "【卦辭】：夬，揚于王庭，孚號有厲。告自邑，不利即戎，利有攸往。",
        tuan: "【彖】：夬，決也，剛決柔也。健而說，決而和。揚于王庭，柔乘五剛也；孚號有厲，其危乃光也；告自邑，不利即戎，所尚乃窮也；利有攸往，剛長乃終也。",
        xiang: "【象】：澤上於天，夬。君子以施祿及下，居德則忌。",
        yao1: "【初九】：壯于前趾，往不勝為咎。",
        yao2: "【九二】：惕號，莫夜有戎，勿恤。",
        yao3: "【九三】：壯于頄，有凶。君子夬夬，獨行，遇雨若濡。有慍无咎。",
        yao4: "【九四】：臀无膚，其行次且，牽羊悔亡，聞言不信。",
        yao5: "【九五】：莧陸夬夬，中行无咎。",
        yao6: "【上六】：无號，終有凶。",
        yaoXiang1: "【象】：不勝而往，咎也。",
        yaoXiang2: "【象】：有戎勿恤，得中道也。",
        yaoXiang3: "【象】：君子夬夬，終无咎也。",
        yaoXiang4: "【象】：其行次且，位不當也，聞言不信，聰不明也。",
        yaoXiang5: "【象】：中行无咎，中未光也。",
        yaoXiang6: "【象】：无號之凶，終不可長也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "44",
        code : "011111",
        book : "下經", 
        name: "姤",
        fullName: "天風姤",
        gua: "【卦辭】：姤，女壯，勿用取女。",
        tuan: "【彖】：姤，遇也，柔遇剛也。勿用取女，不可與長也。天地相遇，品物咸章也；剛遇中正，天下大行也，姤之時義大矣哉。",
        xiang: "【象】：天下有風，姤，后以施命誥四方。",
        yao1: "【初六】：繫于金柅，貞吉。有攸往，見凶。羸豕孚蹢躅。",
        yao2: "【九二】：包有魚，无咎，不利賓。",
        yao3: "【九三】：臀无膚，其行次且，厲，无大咎。",
        yao4: "【九四】：包无魚，起凶。",
        yao5: "【九五】：以杞包瓜，含章，有隕自天。",
        yao6: "【上九】：姤其角，吝，无咎。",
        yaoXiang1: "【象】：繫于金柅，柔道牽也。",
        yaoXiang2: "【象】：包有魚，義不及賓也。",
        yaoXiang3: "【象】：其行次且，行未牽也。",
        yaoXiang4: "【象】：无魚之凶，遠民也。",
        yaoXiang5: "【象】：九五含章，中正也。有隕自天，志不舍命也。",
        yaoXiang6: "【象】：姤其角，上窮吝也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "45",
        code : "000110",
        book : "下經", 
        name: "萃",
        fullName: "澤地萃",
        gua: "【卦辭】：萃亨，王假有廟，利見大人，亨，利貞。用大牲吉。利有攸往。",
        tuan: "【彖】：萃，聚也。順以說，剛中而應，故聚也。王假有廟，致孝享也；利見大人，亨，聚以正也；用大牲，吉，利有攸往，順天命也。觀其所聚，而天地萬物之情可見矣。",
        xiang: "【象】：澤上於地，萃，君子以除戎器，戒不虞。",
        yao1: "【初六】：有孚不終，乃亂乃萃，若號。一握為笑，勿恤，往无咎。",
        yao2: "【六二】：引吉，无咎，孚乃利用禴。",
        yao3: "【六三】：萃如嗟如，无攸利。往无咎，小吝。",
        yao4: "【九四】：大吉，无咎。",
        yao5: "【九五】：萃有位，无咎，匪孚。元永貞，悔亡。",
        yao6: "【上六】：齎咨涕洟，无咎。",
        yaoXiang1: "【象】：乃亂乃萃，其志亂也。",
        yaoXiang2: "【象】：引吉无咎，中未變也。",
        yaoXiang3: "【象】：往无咎，上巽也。",
        yaoXiang4: "【象】：大吉无咎，位不當也。",
        yaoXiang5: "【象】：萃有位，志未光也。",
        yaoXiang6: "【象】：齎咨涕洟，未安上也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "46",
        code : "011000",
        book : "下經", 
        name: "升",
        fullName: "地風升",
        gua: "【卦辭】：升，元亨。用見大人，勿恤。南征吉。",
        tuan: "【彖】：柔以時升，巽而順，剛中而應，是以大亨；用見大人，勿恤，有慶也；南征吉，志行也。",
        xiang: "【象】：地中生木，升。君子以順德，積小以高大。",
        yao1: "【初六】：允升，大吉。",
        yao2: "【九二】：孚乃利用禴，无咎。",
        yao3: "【九三】：升虛邑。",
        yao4: "【六四】：王用亨于岐山，吉，无咎。",
        yao5: "【六五】：貞吉，升階。",
        yao6: "【上六】：冥升，利于不息之貞。",
        yaoXiang1: "【象】：允升大吉，上合志也。",
        yaoXiang2: "【象】：九二之孚，有喜也。",
        yaoXiang3: "【象】：升虛邑，无所疑也。",
        yaoXiang4: "【象】：王用亨于岐山，順事也。",
        yaoXiang5: "【象】：貞吉升階，大得志也。",
        yaoXiang6: "【象】：冥升在上，消不富也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "47",
        code : "010110",
        book : "下經", 
        name: "困",
        fullName: "澤水困",
        gua: "【卦辭】：困，亨，貞大人吉，无咎。有言不信。",
        tuan: "【彖】：困，剛揜也。險以說，困而不失其所亨，其唯君子乎。貞大人吉，以剛中也；有言不信，尚口乃窮也。",
        xiang: "【象】：澤无水，困。君子以致命遂志。",
        yao1: "【初六】：臀困于株木，入于幽谷，三歲不覿。",
        yao2: "【九二】：困于酒食，朱紱方來，利用享祀，征凶，无咎。",
        yao3: "【六三】：困于石，據于蒺蔾，入于其宮，不見其妻，凶。",
        yao4: "【九四】：來徐徐，困于金車。吝，有終。",
        yao5: "【九五】：劓刖，困于赤紱，乃徐有說。利用祭祀。",
        yao6: "【上六】：困于葛藟，于臲卼，曰動悔有悔，征吉。",
        yaoXiang1: "【象】：入于幽谷，幽不明也。",
        yaoXiang2: "【象】：困于酒食，中有慶也。",
        yaoXiang3: "【象】：據于蒺蔾，乘剛也。入于其宮，不見其妻，不祥也。",
        yaoXiang4: "【象】：來徐徐，志在下也。雖不當位，有與也。",
        yaoXiang5: "【象】：劓刖，志未得也；乃徐有說，以中直也；利用祭祀，受福也。",
        yaoXiang6: "【象】：困于葛藟，未當也；動悔有悔，吉行也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "48",
        code : "011010",
        book : "下經", 
        name: "井",
        fullName: "水風井",
        gua: "【卦辭】：井，改邑不改井，无喪无得，往來井井，汔至，亦未繘井，羸其瓶，凶。",
        tuan: "【彖】：巽乎水而上水，井，井養而不窮也。改邑不改井，乃以剛中也；汔至亦未繘井，未有功也；羸其瓶，是以凶也。",
        xiang: "【象】：木上有水，井，君子以勞民勸相。",
        yao1: "【初六】：井泥不食，舊井无禽。",
        yao2: "【九二】：井谷射鮒，甕敝漏。",
        yao3: "【九三】：井渫不食，為我心惻，可用汲。王明，並受其福。",
        yao4: "【六四】：井甃无咎。",
        yao5: "【九五】：井洌，寒泉食。",
        yao6: "【上六】：井收勿幕，有孚元吉。",
        yaoXiang1: "【象】：井泥不食，下也；舊井无禽，時舍也。",
        yaoXiang2: "【象】：井谷射鮒，无與也。",
        yaoXiang3: "【象】：井渫不食，行惻也；求王明，受福也。",
        yaoXiang4: "【象】：井甃无咎，脩井也。",
        yaoXiang5: "【象】：寒泉之食，中正也。",
        yaoXiang6: "【象】：元吉在上，大成也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "49",
        code : "101110",
        book : "下經", 
        name: "革",
        fullName: "澤火革",
        gua: "【卦辭】：革，已日乃孚，元亨利貞，悔亡。",
        tuan: "【彖】：革，水火相息，二女同居，其志不相得，曰革。已日乃孚，革而信之，文明以說，大亨以正，革而當，其悔乃亡。天地革而四時成，湯武革命，順乎天而應乎人，革之時大矣哉。",
        xiang: "【象】：澤中有火，革，君子以治曆明時。",
        yao1: "【初九】：鞏用黃牛之革。",
        yao2: "【六二】：已日乃革之，征吉，无咎。",
        yao3: "【九三】：征凶，貞厲，革言三就，有孚。",
        yao4: "【九四】：悔亡，有孚，改命吉。",
        yao5: "【九五】：大人虎變，未占有孚。",
        yao6: "【上六】：君子豹變，小人革面，征凶，居貞吉。",
        yaoXiang1: "【象】：鞏用黃牛，不可以有為也。",
        yaoXiang2: "【象】：已日革之，行有嘉也。",
        yaoXiang3: "【象】：革言三就，又何之矣。",
        yaoXiang4: "【象】：改命之吉，信志也。",
        yaoXiang5: "【象】：大人虎變，其文炳也。",
        yaoXiang6: "【象】：君子豹變，其文蔚也；小人革面，順以從君也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "50",
        code : "011101",
        book : "下經", 
        name: "鼎",
        fullName: "火風鼎",
        gua: "【卦辭】：鼎，元吉，亨。",
        tuan: "【彖】：鼎，象也。以木巽火，亨飪也。聖人亨以享上帝，而大亨以養聖賢。巽而耳目聰明，柔進而上行，得中而應乎剛，是以元亨。",
        xiang: "【象】：木上有火，鼎，君子以正位凝命。",
        yao1: "【初六】：鼎顛趾，利出否，得妾以其子，无咎。",
        yao2: "【九二】：鼎有實，我仇有疾，不我能即，吉。",
        yao3: "【九三】：鼎耳革，其行塞，雉膏不食。方雨虧悔，終吉。",
        yao4: "【九四】：鼎折足，覆公餗，其形渥，凶。",
        yao5: "【六五】：鼎黃耳金鉉，利貞。",
        yao6: "【上九】：鼎玉鉉，大吉，无不利。",
        yaoXiang1: "【象】：鼎顛趾，未悖也。利出否，以從貴也。",
        yaoXiang2: "【象】：鼎有實，慎所之也。我仇有疾，終无尤也。",
        yaoXiang3: "【象】：鼎耳革，失其義也。",
        yaoXiang4: "【象】：覆公餗，信如何也。",
        yaoXiang5: "【象】：鼎黃耳，中以為實也。",
        yaoXiang6: "【象】：玉鉉在上，剛柔節也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "51",
        code : "100100",
        book : "下經", 
        name: "震",
        fullName: "震為雷",
        gua: "【卦辭】：震，亨。震來虩虩，笑言啞啞，震驚百里，不喪匕鬯。",
        tuan: "【彖】：震，亨。震來虩虩，恐致福也；笑言啞啞，後有則也；震驚百里，驚遠而懼邇也，出可以守宗廟社稷，以為祭主也。",
        xiang: "【象】：洊雷震，君子以恐懼脩省。",
        yao1: "【初九】：震來虩虩，後笑言啞啞，吉。",
        yao2: "【六二】：震來厲，億喪貝，躋于九陵。勿逐，七日得。",
        yao3: "【六三】：震蘇蘇，震行无眚。",
        yao4: "【九四】：震遂泥。",
        yao5: "【六五】：震往來厲，億无喪，有事。",
        yao6: "【上六】：震索索，視矍矍，征凶。震不于其躬于其鄰，无咎。婚媾有言。",
        yaoXiang1: "【象】：震來虩虩，恐致福也；笑言啞啞，後有則也。",
        yaoXiang2: "【象】：震來厲，乘剛也。",
        yaoXiang3: "【象】：震蘇蘇，位不當也。",
        yaoXiang4: "【象】：震遂泥，未光也。",
        yaoXiang5: "【象】：震往來厲，危行也。其事在中，大无喪也。",
        yaoXiang6: "【象】：震索索，中未得也；雖凶无咎，畏鄰戒也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "52",
        code : "001001",
        book : "下經", 
        name: "艮",
        fullName: "艮為山",
        gua: "【卦辭】：艮其背，不獲其身；行其庭，不見其人。无咎。",
        tuan: "【彖】：艮，止也，時止則止，時行則行，動靜不失其時，其道光明。艮其止，止其所也。上下敵應，不相與也，是以不獲其身。行其庭不見其人，无咎也。",
        xiang: "【象】：兼山，艮，君子以思不出其位。",
        yao1: "【初六】：艮其趾，无咎，利永貞。",
        yao2: "【六二】：艮其腓，不拯其隨，其心不快。",
        yao3: "【九三】：艮其限，列其夤，厲薰心。",
        yao4: "【六四】：艮其身，无咎。",
        yao5: "【六五】：艮其輔，言有序，悔亡。",
        yao6: "【上九】：敦艮，吉。",
        yaoXiang1: "【象】：艮其趾，未失正也。",
        yaoXiang2: "【象】：不拯其隨，未退聽也。",
        yaoXiang3: "【象】：艮其限，危薰心也。",
        yaoXiang4: "【象】：艮其身，止諸躬也。",
        yaoXiang5: "【象】：艮其輔，以中正也。",
        yaoXiang6: "【象】：敦艮之吉，以厚終也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "53",
        code : "001011",
        book : "下經", 
        name: "漸",
        fullName: "風山漸",
        gua: "【卦辭】：漸，女歸吉，利貞。",
        tuan: "【彖】：漸之進也，女歸吉也。進得位，往有功也。進以正，可以正邦也。其位剛得中也。止而巽，動不窮也。",
        xiang: "【象】：山上有木，漸，君子以居賢德善俗。",
        yao1: "【初六】：鴻漸于干，小子厲，有言，无咎。",
        yao2: "【六二】：鴻漸于磐，飲食衎衎，吉。",
        yao3: "【九三】：鴻漸于陸，夫征不復，婦孕不育，凶，利禦寇。",
        yao4: "【六四】：鴻漸于木，或得其桷，无咎。",
        yao5: "【九五】：鴻漸于陵，婦三歲不孕，終莫之勝，吉。",
        yao6: "【上九】：鴻漸于陸，其羽可用為儀，吉。",
        yaoXiang1: "【象】：小子之厲，義无咎也。",
        yaoXiang2: "【象】：飲食衎衎，不素飽也。",
        yaoXiang3: "【象】：夫征不復，離群醜也；婦孕不育，失其道也；利用禦寇，順相保也。",
        yaoXiang4: "【象】：或得其桷，順以巽也。",
        yaoXiang5: "【象】：終莫之勝，吉，得所願也。",
        yaoXiang6: "【象】：其羽可用為儀，吉，不可亂也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "54",
        code : "110100",
        book : "下經", 
        name: "歸妹",
        fullName: "雷澤歸妹",
        gua: "【卦辭】：歸妹，征凶，无攸利。",
        tuan: "【彖】：歸妹，天地之大義也。天地不交，而萬物不興。歸妹，人之終始也，說以動，所歸妹也。征凶，位不當也；无攸利，柔乘剛也。",
        xiang: "【象】：澤上有雷，歸妹。君子以永終知敝。",
        yao1: "【初九】：歸妹以娣，跛能履，征吉。",
        yao2: "【九二】：眇能視，利幽人之貞。",
        yao3: "【六三】：歸妹以須，反歸以娣。",
        yao4: "【九四】：歸妹愆期，遲歸有時。",
        yao5: "【六五】：帝乙歸妹，其君之袂，不如其娣之袂良。月幾望，吉。",
        yao6: "【上六】：女承筐无實，士刲羊无血，无攸利。",
        yaoXiang1: "【象】：歸妹以娣，以恒也；跛能履，吉，相承也。",
        yaoXiang2: "【象】：利幽人之貞，未變常也。",
        yaoXiang3: "【象】：歸妹以須，未當也。",
        yaoXiang4: "【象】：愆期之志，有待而行也。",
        yaoXiang5: "【象】：帝乙歸妹，不如其娣之袂良也。其位在中，以貴行也。",
        yaoXiang6: "【象】：上六无實，承虛筐也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "55",
        code : "101100",
        book : "下經", 
        name: "豐",
        fullName: "雷火豐",
        gua: "【卦辭】：豐亨，王假之，勿憂，宜日中。",
        tuan: "【彖】：豐，大也。明以動，故豐。王假之，尚大也；勿憂，宜日中，宜照天下也。日中則昃，月盈則食，天地盈虛，與時消息，而況於人乎？況於鬼神乎？",
        xiang: "【象】：雷電皆至，豐，君子以折獄致刑。",
        yao1: "【初九】：遇其配主，雖旬无咎，往有尚。",
        yao2: "【六二】：豐其蔀，日中見斗。往得疑疾，有孚發若，吉。",
        yao3: "【九三】：豐其沛，日中見沬。折其右肱，无咎。",
        yao4: "【九四】：豐其蔀，日中見斗，遇其夷主，吉。",
        yao5: "【六五】：來章，有慶譽，吉。",
        yao6: "【上六】：豐其屋，蔀其家，闚其戶，闃其无人，三歲不覿，凶。",
        yaoXiang1: "【象】：雖旬无咎，過旬災也。",
        yaoXiang2: "【象】：有孚發若，信以發志也。",
        yaoXiang3: "【象】：豐其沛，不可大事也；折其右肱，終不可用也。",
        yaoXiang4: "【象】：豐其蔀，位不當也；日中見斗，幽不明也；遇其夷主，吉行也。",
        yaoXiang5: "【象】：六五之吉，有慶也。",
        yaoXiang6: "【象】：豐其屋，天際翔也；闚其戶，闃其无人，自藏也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "56",
        code : "001101",
        book : "下經", 
        name: "旅",
        fullName: "火山旅",
        gua: "【卦辭】：旅，小亨，旅貞吉。",
        tuan: "【彖】：旅，小亨，柔得中乎外而順乎剛，止而麗乎明，是以小亨，旅貞吉也，旅之時義大矣哉。",
        xiang: "【象】：山上有火，旅，君子以明慎用刑而不留獄。",
        yao1: "【初六】：旅瑣瑣，斯其所取災。",
        yao2: "【六二】：旅即次，懷其資，得童僕貞。",
        yao3: "【九三】：旅焚其次，喪其童僕，貞厲。",
        yao4: "【九四】：旅于處，得其資斧，我心不快。",
        yao5: "【六五】：射雉，一矢亡，終以譽命。",
        yao6: "【上九】：鳥焚其巢，旅人先笑後號咷，喪牛于易，凶。",
        yaoXiang1: "【象】：旅瑣瑣，志窮災也。",
        yaoXiang2: "【象】：得童僕貞，終无尤也。",
        yaoXiang3: "【象】：旅焚其次，亦以傷矣。以旅與下，其義喪也。",
        yaoXiang4: "【象】：旅于處，未得位也；得其資斧，心未快也。",
        yaoXiang5: "【象】：終以譽命，上逮也。",
        yaoXiang6: "【象】：以旅在上，其義焚也；喪牛于易，終莫之聞也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "57",
        code : "011011",
        book : "下經", 
        name: "巽",
        fullName: "巽為風",
        gua: "【卦辭】：巽，小亨，利有攸往，利見大人。",
        tuan: "【彖】：重巽以申命，剛巽乎中正而志行，柔皆順乎剛，是以小亨，利有攸往，利見大人。",
        xiang: "【象】：隨風，巽，君子以申命行事。",
        yao1: "【初六】：進退，利武人之貞。",
        yao2: "【九二】：巽在床下，用史巫紛若，吉无咎。",
        yao3: "【九三】：頻巽，吝。",
        yao4: "【六四】：悔亡，田獲三品。",
        yao5: "【九五】：貞吉，悔亡，无不利。无初有終，先庚三日，後庚三日，吉。",
        yao6: "【上九】：巽在床下，喪其資斧，貞凶。",
        yaoXiang1: "【象】：進退，志疑也；利武人之貞，志治也。",
        yaoXiang2: "【象】：紛若之吉，得中也。",
        yaoXiang3: "【象】：頻巽之吝，志窮也。",
        yaoXiang4: "【象】：田獲三品，有功也。",
        yaoXiang5: "【象】：九五之吉，位正中也。",
        yaoXiang6: "【象】：巽在床下，上窮也；喪其資斧，正乎凶也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "58",
        code : "110110",
        book : "下經", 
        name: "兌",
        fullName: "兌為澤",
        gua: "【卦辭】：兌，亨，利貞。",
        tuan: "【彖】：兌，說也。剛中而柔外，說以利貞，是以順乎天而應乎人。說以先民，民忘其勞，說以犯難，民忘其死，說之大，民勸矣哉。",
        xiang: "【象】：麗澤，兌。君子以朋友講習。",
        yao1: "【初九】：和兌吉。",
        yao2: "【九二】：孚兌，吉，悔亡。",
        yao3: "【六三】：來兌，凶。",
        yao4: "【九四】：商兌未寧，介疾有喜。",
        yao5: "【九五】：孚于剝，有厲。",
        yao6: "【上六】：引兌。",
        yaoXiang1: "【象】：和兌之吉，行未疑也。",
        yaoXiang2: "【象】：孚兌之吉，信志也。",
        yaoXiang3: "【象】：來兌之凶，位不當也。",
        yaoXiang4: "【象】：九四之喜，有慶也。",
        yaoXiang5: "【象】：孚于剝，位正當也。",
        yaoXiang6: "【象】：上六引兌，未光也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "59",
        code : "010011",
        book : "下經", 
        name: "渙",
        fullName: "風水渙",
        gua: "【卦辭】：渙亨，王假有廟，利涉大川，利貞。",
        tuan: "【彖】：渙亨，剛來而不窮，柔得位乎外而上同。王假有廟，王乃在中也。利涉大川，乘木有功也。",
        xiang: "【象】：風行水上，渙，先王以享于帝，立廟。",
        yao1: "【初六】：用拯馬壯，吉。",
        yao2: "【九二】：渙奔其机，悔亡。",
        yao3: "【六三】：渙其躬，无悔。",
        yao4: "【六四】：渙其群，元吉。渙有丘，匪夷所思。",
        yao5: "【九五】：渙其汗，大號，渙王居，无咎。",
        yao6: "【上九】：渙其血，去逖出，无咎。",
        yaoXiang1: "【象】：初六之吉，順也。",
        yaoXiang2: "【象】：渙奔其机，得願也。",
        yaoXiang3: "【象】：渙其躬，志在外也。",
        yaoXiang4: "【象】：渙其群，元吉，光大也。",
        yaoXiang5: "【象】：王居无咎，正位也。",
        yaoXiang6: "【象】：渙其血，遠害也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "60",
        code : "110010",
        book : "下經", 
        name: "節",
        fullName: "水澤節",
        gua: "【卦辭】：節亨。苦節，不可貞。",
        tuan: "【彖】：節亨，剛柔分而剛得中。苦節不可貞，其道窮也。說以行險，當位以節，中正以通。天地節而四時成，節以制度，不傷財，不害民。",
        xiang: "【象】：澤上有水，節。君子以制數度，議德行。",
        yao1: "【初九】：不出戶庭，无咎。",
        yao2: "【九二】：不出門庭，凶。",
        yao3: "【六三】：不節若，則嗟若，无咎。",
        yao4: "【六四】：安節，亨。",
        yao5: "【九五】：甘節，吉，往有尚。",
        yao6: "【上六】：苦節，貞凶，悔亡。",
        yaoXiang1: "【象】：不出戶庭，知通塞也。",
        yaoXiang2: "【象】：不出門庭凶，失時極也。",
        yaoXiang3: "【象】：不節之嗟，又誰咎也。",
        yaoXiang4: "【象】：安節之亨，承上道也。",
        yaoXiang5: "【象】：甘節之吉，居位中也。",
        yaoXiang6: "【象】：苦節貞凶，其道窮也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "61",
        code : "110011",
        book : "下經", 
        name: "中孚",
        fullName: "風澤中孚",
        gua: "【卦辭】：中孚，豚魚吉，利涉大川，利貞。",
        tuan: "【彖】：中孚，柔在內而剛得中，說而巽，孚，乃化邦也。豚魚吉，信及豚魚也；利涉大川，乘木舟虛也；中孚以利貞，乃應乎天也。",
        xiang: "【象】：澤上有風，中孚，君子以議獄緩死。",
        yao1: "【初九】：虞吉，有它不燕。",
        yao2: "【九二】：鳴鶴在陰，其子和之；我有好爵，吾與爾靡之。",
        yao3: "【六三】：得敵，或鼓或罷，或泣或歌。",
        yao4: "【六四】：月幾望，馬匹亡，无咎。",
        yao5: "【九五】：有孚攣如，无咎。",
        yao6: "【上九】：翰音登于天，貞凶。",
        yaoXiang1: "【象】：初九虞吉，志未變也。",
        yaoXiang2: "【象】：其子和之，中心願也。",
        yaoXiang3: "【象】：或鼓或罷，位不當也。",
        yaoXiang4: "【象】：馬匹亡，絕類上也。",
        yaoXiang5: "【象】：有孚攣如，位正當也。",
        yaoXiang6: "【象】：翰音登于天，何可長也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "62",
        code : "001100",
        book : "下經", 
        name: "小過",
        fullName: "雷山小過",
        gua: "【卦辭】：小過，亨，利貞。可小事，不可大事。飛鳥遺之音，不宜上，宜下。大吉。",
        tuan: "【彖】：小過，小者過而亨也，過以利貞，與時行也。柔得中，是以小事吉也；剛失位而不中，是以不可大事也。有飛鳥之象焉，飛鳥遺之音，不宜上，宜下，大吉，上逆而下順也。",
        xiang: "【象】：山上有雷，小過。君子以行過乎恭，喪過乎哀，用過乎儉。",
        yao1: "【初六】：飛鳥以凶。",
        yao2: "【六二】：過其祖，遇其妣，不及其君，遇其臣，无咎。",
        yao3: "【九三】：弗過防之，從或戕之，凶。",
        yao4: "【九四】：无咎，弗過遇之，往厲必戒，勿用永貞。",
        yao5: "【六五】：密雲不雨，自我西郊，公弋取彼在穴。",
        yao6: "【上六】：弗遇過之，飛鳥離之，凶，是謂災眚。",
        yaoXiang1: "【象】：飛鳥以凶，不可如何也。",
        yaoXiang2: "【象】：不及其君，臣不可過也。",
        yaoXiang3: "【象】：從或戕之，凶如何也。",
        yaoXiang4: "【象】：弗過遇之，位不當也；往厲必戒，終不可長也。",
        yaoXiang5: "【象】：密雲不雨，已上也。",
        yaoXiang6: "【象】：弗遇過之，已亢也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "63",
        code : "101010",
        book : "下經", 
        name: "既濟",
        fullName: "水火既濟",
        gua: "【卦辭】：既濟，亨小，利貞。初吉終亂。",
        tuan: "【彖】：既濟亨，小者亨也。利貞，剛柔正而位當也。初吉，柔得中也，終止則亂，其道窮也。",
        xiang: "【象】：水在火上，既濟，君子以思患而豫防之。",
        yao1: "【初九】：曳其輪，濡其尾，无咎。",
        yao2: "【六二】：婦喪其茀，勿逐，七日得。",
        yao3: "【九三】：高宗伐鬼方，三年克之，小人勿用。",
        yao4: "【六四】：繻有衣袽，終日戒。",
        yao5: "【九五】：東鄰殺牛，不如西鄰之禴祭，實受其福。",
        yao6: "【上六】：濡其首，厲。",
        yaoXiang1: "【象】：曳其輪，義无咎也。",
        yaoXiang2: "【象】：七日得，以中道也。",
        yaoXiang3: "【象】：三年克之，憊也。",
        yaoXiang4: "【象】：終日戒，有所疑也。",
        yaoXiang5: "【象】：東鄰殺牛，不如西鄰之時也，實受其福，吉大來也。",
        yaoXiang6: "【象】：濡其首厲，何可久也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "64",
        code : "010101",
        book : "下經", 
        name: "未濟",
        fullName: "火水未濟",
        gua: "【卦辭】：未濟，亨。小狐汔濟，濡其尾，无攸利。",
        tuan: "【彖】：未濟亨，柔得中也；小狐汔濟，未出中也；濡其尾，无攸利，不續終也，雖不當位，剛柔應也。",
        xiang: "【象】：火在水上，未濟，君子以慎辨物居方。",
        yao1: "【初六】：濡其尾，吝。",
        yao2: "【九二】：曳其輪，貞吉。",
        yao3: "【六三】：未濟，征凶，利涉大川。",
        yao4: "【九四】：貞吉，悔亡，震用伐鬼方，三年有賞于大國。",
        yao5: "【六五】：貞吉无悔，君子之光，有孚，吉。",
        yao6: "【上九】：有孚于飲酒，无咎。濡其首，有孚，失是。",
        yaoXiang1: "【象】：濡其尾，亦不知極也。",
        yaoXiang2: "【象】：九二貞吉，中以行正也。",
        yaoXiang3: "【象】：未濟征凶，位不當也。",
        yaoXiang4: "【象】：貞吉悔亡，志行也。",
        yaoXiang5: "【象】：君子之光，其暉吉也。",
        yaoXiang6: "【象】：飲酒濡首，亦不知節也。",
        yong9: "",
        yong6: ""
    },
]

export const gua64 = [
    {
        id : "1",
        code : "111111",
        book : "上經", 
        name: "乾",
        fullName: "乾為天",
        gua: "【卦辭】：元，亨，利，貞",
        tuan: "【彖】：大哉乾元，萬物資始，乃統天。雲行雨施，品物流形，大明終始，六位時成，時乘六龍以御天。乾道變化，各正性命，保合大和，乃利貞。首出庶物，萬國咸寧。",
        xiang: "【象】：天行健，君子以自強不息。潛龍勿用，陽在下也。見龍在田，德施普也。終日乾乾，反復道也。或躍在淵，進无咎也，飛龍在天，大人造也。亢龍有悔，盈不可久也。用九，天德不可為首也。",
        yao1: "【初九】：潛龍勿用。",
        yao2: "【九二】：見龍在田，利見大人。",
        yao3: "【九三】：君子終日乾乾，夕惕若，厲无咎。",
        yao4: "【九四】：或躍在淵，无咎。",
        yao5: "【九五】：飛龍在天，利見大人。",
        yao6: "【上九】：亢龍有悔。",
        yaoXiang1: "【象】：潛龍勿用，陽在下也。",
        yaoXiang2: "【象】：見龍在田，德施普也。",
        yaoXiang3: "【象】：終日乾乾，反復道也。",
        yaoXiang4: "【象】：或躍在淵，進无咎也。",
        yaoXiang5: "【象】：飛龍在天，大人造也。",
        yaoXiang6: "【象】：亢龍有悔，盈不可久也。",
        yong9: "【用九】：見群龍无首，吉。",
        yong6: ""
    },
    {
        id: "2",
        code : "000000",
        book : "上經", 
        name: "坤",
        fullName: "坤為地",
        gua: "【卦辭】：元亨，利牝馬之貞。君子有攸往。先迷後得，主利，西南得朋，東北喪朋，安貞吉。",
        tuan: "【彖】：至哉坤元，萬物資生，乃順承天。坤厚載物，德合无疆，含弘光大，品物咸亨。牝馬地類，行地无疆，柔順利貞。君子攸行，先迷失道，後順得常。西南得朋，乃與類行，東北喪朋，乃終有慶。安貞之吉，應地无疆。",
        xiang: "【象】：地勢坤，君子以厚德載物。",
        yao1: "【初六】：履霜，堅冰至。",
        yao2: "【六二】：直方大，不習无不利。",
        yao3: "【六三】：含章可貞，或從王事，无成有終。",
        yao4: "【六四】：括囊，无咎无譽。",
        yao5: "【六五】：黃裳，元吉。",
        yao6: "【上六】：龍戰于野，其血玄黃。",
        yaoXiang1: "【象】：履霜堅冰，陰始凝也。馴致其道，至堅冰也。",
        yaoXiang2: "【象】：六二之動，直以方也。不習无不利，地道光也。",
        yaoXiang3: "【象】：含章可貞，以時發也；或從王事，知光大也。",
        yaoXiang4: "【象】：括囊无咎，慎不害也。",
        yaoXiang5: "【象】：黃裳元吉，文在中也。",
        yaoXiang6: "【象】：龍戰于野，其道窮也。",
        yong9: "",
        yong6: "【用六】：利永貞。"
    },
    {
        id: "3",
        code : "100010",
        book : "上經", 
        name: "屯",
        fullName: "水雷屯",
        gua: "【卦辭】：元亨利貞，勿用有攸往，利建侯。",
        tuan: "【彖】：屯，剛柔始交而難生，動乎險中，大亨貞。雷雨之動滿盈，天造草昧，宜建侯而不寧。",
        xiang: "【象】：雲雷屯，君子以經綸。",
        yao1: "【初九】：磐桓，利居貞，利建侯。",
        yao2: "【六二】：屯如邅如，乘馬班如，匪寇婚媾。女子貞不字，十年乃字。",
        yao3: "【六三】：即鹿无虞，惟入于林中。君子幾不如舍。往吝。",
        yao4: "【六四】：乘馬班如，求婚媾，往，吉无不利。",
        yao5: "【九五】：屯其膏，小貞吉，大貞凶。",
        yao6: "【上六】：乘馬班如，泣血漣如。",
        yaoXiang1: "【象】：雖磐桓，志行正也。以貴下賤，大得民也。",
        yaoXiang2: "【象】：六二之難，乘剛也。十年乃字，反常也。",
        yaoXiang3: "【象】：即鹿无虞，以從禽也。君子舍之，往吝窮也。",
        yaoXiang4: "【象】：求而往，明也。",
        yaoXiang5: "【象】：屯其膏，施未光也。",
        yaoXiang6: "【象】：泣血漣如，何可長也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "4",
        code : "010001",
        book : "上經", 
        name: "蒙",
        fullName: "山水蒙",
        gua: "【卦辭】：亨。匪我求童蒙，童蒙求我。初筮告，再三瀆，瀆則不告。利貞。",
        tuan: "【彖】：蒙，山下有險，險而止，蒙。蒙，亨，以亨行，時中也。匪我求童蒙，童蒙求我，志應也。初筮告，以剛中也。再三瀆，瀆則不告，瀆蒙也。蒙以養正，聖功也。",
        xiang: "【象】：山下出泉，蒙，君子以果行育德。",
        yao1: "【初六】：發蒙。利用刑人，用說桎梏，以往吝。",
        yao2: "【九二】：包蒙，吉。納婦吉，子克家。",
        yao3: "【六三】：勿用取女，見金夫，不有躬，无攸利。",
        yao4: "【六四】：困蒙，吝。",
        yao5: "【六五】：童蒙，吉。",
        yao6: "【上九】：擊蒙，不利為寇，利禦寇。",
        yaoXiang1: "【象】：利用刑人，以正法也。",
        yaoXiang2: "【象】：子克家，剛柔接也。",
        yaoXiang3: "【象】：勿用取女，行不順也。",
        yaoXiang4: "【象】：困蒙之吝，獨遠實也。",
        yaoXiang5: "【象】：童蒙之吉，順以巽也。",
        yaoXiang6: "【象】：利用禦寇，上下順也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "5",
        code : "111010",
        book : "上經", 
        name: "需",
        fullName: "水天需",
        gua: "【卦辭】：有孚，光亨，貞吉，利涉大川。",
        tuan: "【彖】：需，須也，險在前也。剛健而不陷，其義不困窮矣。需，有孚，光亨，貞吉，位乎天位，以正中也。利涉大川，往有功也。",
        xiang: "【象】：雲上於天，需，君子以飲食宴樂。",
        yao1: "【初九】：需于郊，利用恒，无咎。",
        yao2: "【九二】：需于沙，小有言，終吉。",
        yao3: "【九三】：需于泥，致寇至。",
        yao4: "【六四】：需于血，出自穴。",
        yao5: "【九五】：需于酒食，貞吉。",
        yao6: "【上六】：入于穴，有不速之客三人來，敬之，終吉。",
        yaoXiang1: "【象】：需于郊，不犯難行也。利用恆，无咎，未失常也。",
        yaoXiang2: "【象】：需于沙，衍在中也，雖小有言，以吉終也*。　*「以吉終也」或作「終吉也」。",
        yaoXiang3: "【象】：需于泥，災在外也。自我致寇，敬慎不敗也。",
        yaoXiang4: "【象】：需于血，順以聽也。",
        yaoXiang5: "【象】：酒食貞吉，以中正也。",
        yaoXiang6: "【象】：不速之客來，敬之終吉，雖不當位，未大失也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "6",
        code : "010111",
        book : "上經", 
        name: "訟",
        fullName: "天水訟",
        gua: "【卦辭】：訟，有孚窒惕，中吉，終凶。利見大人，不利涉大川。",
        tuan: "【彖】：訟，上剛下險，險而健，訟。訟有孚窒惕中吉，剛來而得中也。終凶，訟不可成也。利見大人，尚中正也。不利涉大川，入于淵也。",
        xiang: "【象】：天與水違行，訟。君子以作事謀始。",
        yao1: "【初六】：不永所事，小有言，終吉。",
        yao2: "【九二】：不克訟，歸而逋其邑，人三百戶，无眚。",
        yao3: "【六三】：食舊德，貞厲，終吉，或從王事，无成。",
        yao4: "【九四】：不克訟，復即命渝，安貞吉。",
        yao5: "【九五】：訟，元吉。",
        yao6: "【上九】：或錫之鞶帶，終朝三褫之。",
        yaoXiang1: "【象】：不永所事，訟不可長也。雖小有言，其辯明也。",
        yaoXiang2: "【象】：不克訟，歸逋，竄也。自下訟上，患至掇也。",
        yaoXiang3: "【象】：食舊德，從上吉也。",
        yaoXiang4: "【象】：復即命渝，安貞不失也。",
        yaoXiang5: "【象】：訟元吉，以中正也。",
        yaoXiang6: "【象】：以訟受服，亦不足敬也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "7",
        code : "010000",
        book : "上經", 
        name: "師",
        fullName: "地水師",
        gua: "【卦辭】：師貞，丈人吉，无咎。",
        tuan: "【彖】：師眾也，貞正也，能以眾正，可以王矣。剛中而應，行險而順，以此毒天下，而民從之，吉又何咎矣。",
        xiang: "【象】：地中有水，師，君子以容民畜眾。",
        yao1: "【初六】：師出以律，否臧凶。",
        yao2: "【九二】：在師中吉，无咎，王三錫命。",
        yao3: "【六三】：師或輿尸，凶。",
        yao4: "【六四】：師左次，无咎。",
        yao5: "【六五】：田有禽，利執言，无咎。長子帥師，弟子輿尸，貞凶。",
        yao6: "【上六】：大君有命，開國承家，小人勿用。",
        yaoXiang1: "【象】：師出以律，失律凶也。",
        yaoXiang2: "【象】：在師中吉，承天寵也；王三錫命，懷萬邦也。",
        yaoXiang3: "【象】：師或輿尸，大无功也。",
        yaoXiang4: "【象】：左次无咎，未失常也。",
        yaoXiang5: "【象】：長子帥師，以中行也；弟子輿尸，使不當也。",
        yaoXiang6: "【象】：大君有命，以正功也；小人勿用，必亂邦也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "8",
        code : "000010",
        book : "上經", 
        name: "比",
        fullName: "水地比",
        gua: "【卦辭】：比，吉，原筮，元永貞，无咎。不寧方來，後夫凶。",
        tuan: "【彖】：比，吉也。比，輔也，下順從也。原筮元永貞，无咎，以剛中也。不寧方來，上下應也。後夫凶，其道窮也。",
        xiang: "【象】：地上有水，比。先王以建萬國，親諸侯。",
        yao1: "【初六】：有孚，比之无咎。有孚盈缶，終來，有它吉。",
        yao2: "【六二】：比之自內，貞吉。",
        yao3: "【六三】：比之匪人。",
        yao4: "【六四】：外比之，貞吉。",
        yao5: "【九五】：顯比，王用三驅，失前禽，邑人不誡，吉。",
        yao6: "【上六】：比之无首，凶。",
        yaoXiang1: "【象】：比之初六】：有它吉也。",
        yaoXiang2: "【象】：比之自內，不自失也。",
        yaoXiang3: "【象】：比之匪人，不亦傷乎。",
        yaoXiang4: "【象】：外比於賢，以從上也。",
        yaoXiang5: "【象】：顯比之吉，位正中也；舍逆取順，失前禽也；邑人不誡，上使中也。",
        yaoXiang6: "【象】：比之无首，无所終也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "9",
        code : "111011",
        book : "上經", 
        name: "小畜",
        fullName: "風天小畜",
        gua: "【卦辭】：小畜，亨。密雲不雨，自我西郊。",
        tuan: "【彖】：小畜，柔得位而上下應之，曰小畜。健而巽，剛中而志行，乃亨。密雲不雨，尚往也；自我西郊，施未行也。",
        xiang: "【象】：風行天上，小畜，君子以懿文德。",
        yao1: "【初九】：復自道，何其咎，吉。",
        yao2: "【九二】：牽復，吉。",
        yao3: "【九三】：輿說輻，夫妻反目。",
        yao4: "【六四】：有孚，血去惕出，无咎。",
        yao5: "【九五】：有孚攣如，富以其鄰。",
        yao6: "【上九】：既雨既處，尚德載，婦貞厲。月幾望，君子征凶。",
        yaoXiang1: "【象】：復自道，其義吉也。",
        yaoXiang2: "【象】：牽復在中，亦不自失也。",
        yaoXiang3: "【象】：夫妻反目，不能正室也。",
        yaoXiang4: "【象】：有孚惕出，上合志也。",
        yaoXiang5: "【象】：有孚攣如，不獨富也。",
        yaoXiang6: "【象】：既雨既處，德積載也；君子征凶，有所疑也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "10",
        code : "110111",
        book : "上經", 
        name: "履",
        fullName: "天澤履",
        gua: "【卦辭】：履虎尾，不咥人，亨。",
        tuan: "【彖】：履，柔履剛也。說而應乎乾，是以履虎尾，不咥人，亨。剛中正，履帝位而不疚，光明也。",
        xiang: "【象】：上天下澤，履，君子以辯上下，定民志。",
        yao1: "【初九】：素履，往无咎。",
        yao2: "【九二】：履道坦坦，幽人貞吉。",
        yao3: "【六三】：眇能視，跛能履，履虎尾，咥人凶。武人為于大君。",
        yao4: "【九四】：履虎尾，愬愬，終吉。",
        yao5: "【九五】：夬履，貞厲。",
        yao6: "【上九】：視履，考祥其旋，元吉。",
        yaoXiang1: "【象】：素履之往，獨行願也。",
        yaoXiang2: "象】：幽人貞吉，中不自亂也。",
        yaoXiang3: "【象】：眇能視，不足以有明也；跛能履，不足以與行也；咥人之凶，位不當也；武人為于大君，志剛也。",
        yaoXiang4: "【象】：愬愬終吉，志行也。",
        yaoXiang5: "【象】：夬履貞厲，位正當也。",
        yaoXiang6: "【象】：元吉在上，大有慶也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "11",
        code : "111000",
        book : "上經", 
        name: "泰",
        fullName: "地天泰",
        gua: "【卦辭】：泰，小往大來，吉亨。",
        tuan: "【彖】：泰，小往大來，吉亨，則是天地交而萬物通也，上下交而其志同也。內陽而外陰，內健而外順，內君子而外小人。君子道長，小人道消也。",
        xiang: "【象】：天地交，泰。后以財成天地之道，輔相天地之宜，以左右民。",
        yao1: "【初九】：拔茅茹，以其彙，征吉。",
        yao2: "【九二】：包荒，用馮河，不遐遺，朋亡，得尚于中行。",
        yao3: "【九三】：无平不陂，无往不復。艱貞无咎。勿恤其孚，于食有福。",
        yao4: "【六四】：翩翩不富以其鄰，不戒以孚。",
        yao5: "【六五】：帝乙歸妹，以祉元吉。",
        yao6: "【上六】：城復于隍，勿用師。自邑告命，貞吝。",
        yaoXiang1: "【象】：拔茅征吉，志在外也。",
        yaoXiang2: "【象】：包荒，得尚于中行，以光大也。",
        yaoXiang3: "【象】：无往不復，天地際也。",
        yaoXiang4: "【象】：翩翩不富，皆失實也；不戒以孚，中心願也。",
        yaoXiang5: "【象】：以祉元吉，中以行願也。",
        yaoXiang6: "【象】：城復于隍，其命亂也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "12",
        code : "000111",
        book : "上經", 
        name: "否",
        fullName: "天地否",
        gua: "【卦辭】：否之匪人，不利君子貞，大往小來。",
        tuan: "【彖】：否之匪人，不利君子貞，大往小來，則是天地不交而萬物不通也，上下不交而天下无邦也。內陰而外陽，內柔而外剛，內小人而外君子，小人道長，君子道消也。",
        xiang: "【象】：天地不交，否。君子以儉德辟難，不可榮以祿。",
        yao1: "【初六】：拔茅茹，以其彙，貞吉，亨。",
        yao2: "【六二】：包承，小人吉，大人否亨。",
        yao3: "【六三】：包羞。",
        yao4: "【九四】：有命无咎，疇離祉。",
        yao5: "【九五】：休否，大人吉。其亡其亡，繫于苞桑。",
        yao6: "【上九】：傾否，先否後喜。",
        yaoXiang1: "【象】：拔茅貞吉，志在君也。",
        yaoXiang2: "【象】：大人否亨，不亂群也。",
        yaoXiang3: "【象】：包羞，位不當也。",
        yaoXiang4: "【象】：有命无咎，志行也。",
        yaoXiang5: "【象】：大人之吉，位正當也。",
        yaoXiang6: "【象】：否終則傾，何可長也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "13",
        code : "101111",
        book : "上經", 
        name: "同人",
        fullName: "天火同人",
        gua: "【卦辭】：同人于野，亨。利涉大川，利君子貞。",
        tuan: "【彖】：同人，柔得位得中而應乎乾，曰同人。同人曰，同人于野，亨，利涉大川，乾行也。文明以健，中正而應，君子正也，唯君子為能通天下之志。",
        xiang: "【象】：天與火，同人。君子以類族辨物。",
        yao1: "【初九】：同人于門，无咎。",
        yao2: "【六二】：同人于宗，吝。",
        yao3: "【九三】：伏戎于莽，升其高陵，三歲不興。",
        yao4: "【九四】：乘其墉，弗克攻，吉。",
        yao5: "【九五】：同人，先號咷而後笑，大師克相遇。",
        yao6: "【上九】：同人于郊，无悔。",
        yaoXiang1: "【象】：出門同人，又誰咎也。",
        yaoXiang2: "【象】：同人于宗，吝道也。",
        yaoXiang3: "【象】：伏戎于莽，敵剛也；三歲不興，安行也。",
        yaoXiang4: "【象】：伏戎于莽，敵剛也；三歲不興，安行也。",
        yaoXiang5: "【象】：同人之先，以中直也；大師相遇，言相克也。",
        yaoXiang6: "【象】：同人于郊，志未得也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "14",
        code : "111101",
        book : "上經", 
        name: "大有",
        fullName: "火天大有",
        gua: "【卦辭】：大有，元亨。",
        tuan: "【彖】：大有，柔得尊位大中，而上下應之，曰大有。其德剛健而文明，應乎天而時行，是以元亨。",
        xiang: "【象】：火在天上，大有。君子以遏惡揚善，順天休命。",
        yao1: "【初九】：无交害，匪咎，艱則无咎。",
        yao2: "【九二】：大車以載，有攸往，无咎。",
        yao3: "【九三】：公用亨于天子，小人弗克。",
        yao4: "【九四】：匪其彭，无咎。",
        yao5: "【六五】：厥孚交如，威如，吉。",
        yao6: "【上九】：自天祐之，吉无不利。",
        yaoXiang1: "【象】：大有初九，无交害也。",
        yaoXiang2: "【象】：大車以載，積中不敗也。",
        yaoXiang3: "【象】：公用亨于天子，小人害也。",
        yaoXiang4: "【象】：匪其彭，无咎，明辨皙也。",
        yaoXiang5: "【象】：厥孚交如，信以發志也。威如之吉，易而无備也。",
        yaoXiang6: "【象】：大有上吉，自天祐也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "15",
        code : "001000",
        book : "上經", 
        name: "謙",
        fullName: "地山謙",
        gua: "【卦辭】：謙，亨，君子有終。",
        tuan: "【彖】：謙亨，天道下濟而光明，地道卑而上行；天道虧盈而益謙，地道變盈而流謙；鬼神害盈而福謙，人道惡盈而好謙。謙尊而光，卑而不可踰，君子之終也。",
        xiang: "【象】：地中有山，謙，君子以裒多益寡，稱物平施。",
        yao1: "【初六】：謙謙君子，用涉大川，吉。",
        yao2: "【六二】：鳴謙，貞吉。",
        yao3: "【九三】：勞謙，君子有終，吉。",
        yao4: "【六四】：无不利，撝謙。",
        yao5: "【六五】：不富以其鄰，利用侵伐，无不利。",
        yao6: "【上六】：鳴謙，利用行師，征邑國。",
        yaoXiang1: "【象】：謙謙君子，卑以自牧也。",
        yaoXiang2: "【象】：鳴謙貞吉，中心得也。",
        yaoXiang3: "【象】：勞謙君子，萬民服也。",
        yaoXiang4: "【象】：无不利，撝謙，不違則也。",
        yaoXiang5: "【象】：利用侵伐，征不服也。",
        yaoXiang6: "【象】：鳴謙，志未得也，可用行師，征邑國也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "16",
        code : "000100",
        book : "上經", 
        name: "豫",
        fullName: "雷地豫",
        gua: "【卦辭】：豫，利建侯、行師。",
        tuan: "【彖】：豫，剛應而志行，順以動，豫。豫順以動，故天地如之，而況建侯行師乎？天地以順動，故日月不過，而四時不忒。聖人以順動，則刑罰清而民服。豫之時義大矣哉。",
        xiang: "【象】：雷出地奮，豫。先王以作樂崇德，殷薦之上帝，以配祖考。",
        yao1: "【初六】：鳴豫，凶。",
        yao2: "【六二】：介于石，不終日，貞吉。",
        yao3: "【六三】：盱豫，悔遲有悔。",
        yao4: "【九四】：由豫，大有得。勿疑，朋盍簪。",
        yao5: "【六五】：貞疾，恒不死。",
        yao6: "【上六】：冥豫，成有渝，无咎。",
        yaoXiang1: "【象】：初六鳴豫，志窮凶也。",
        yaoXiang2: "【象】：不終日，貞吉，以中正也。",
        yaoXiang3: "【象】：盱豫有悔，位不當也。",
        yaoXiang4: "【象】：由豫，大有得，志大行也。",
        yaoXiang5: "【象】：六五】：貞疾，乘剛也。恒不死，中未亡也。",
        yaoXiang6: "【象】：冥豫在上，何可長也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "17",
        code : "100110",
        book : "上經", 
        name: "隨",
        fullName: "澤雷隨",
        gua: "【卦辭】：隨，元亨利貞，无咎。",
        tuan: "【彖】：隨，剛來而下柔，動而說，隨。大亨貞，无咎，而天下隨時，隨時之義大矣哉。",
        xiang: "【象】：澤中有雷，隨。君子以嚮晦入宴息。",
        yao1: "【初九】：官有渝，貞吉。出門交有功。",
        yao2: "【六二】：係小子，失丈夫。",
        yao3: "【六三】：係丈夫，失小子。隨有求得，利居貞。",
        yao4: "【九四】：隨有獲，貞凶。有孚，在道以明，何咎？",
        yao5: "【九五】：孚于嘉，吉。",
        yao6: "【上六】：拘係之，乃從維之，王用亨于西山。",
        yaoXiang1: "【象】：官有渝，從正吉也；出門交有功，不失也。",
        yaoXiang2: "【象】：係小子，弗兼與也。",
        yaoXiang3: "【象】：係丈夫，志舍下也。",
        yaoXiang4: "【象】：隨有獲，其義凶也；有孚在道，明功也。",
        yaoXiang5: "【象】：孚于嘉吉，位正中也。",
        yaoXiang6: "【象】：拘係之。上窮也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "18",
        code : "011001",
        book : "上經", 
        name: "蠱",
        fullName: "山風蠱",
        gua: "【卦辭】：蠱，元亨，利涉大川。先甲三日，後甲三日。",
        tuan: "【彖】：蠱，剛上而柔下，巽而止，蠱。蠱元亨，而天下治也；利涉大川，往有事也；先甲三日，後甲三日，終則有始，天行也。",
        xiang: "【象】：山下有風，蠱。君子以振民育德。",
        yao1: "【初六】：幹父之蠱，有子，考无咎，厲終吉。",
        yao2: "【九二】：幹母之蠱，不可貞。",
        yao3: "【九三】：幹父之蠱，小有悔，无大咎。",
        yao4: "【六四】：裕父之蠱，往見吝。",
        yao5: "【六五】：幹父之蠱，用譽。",
        yao6: "【上九】：不事王侯，高尚其事。",
        yaoXiang1: "【象】：幹父之蠱，意承考也。",
        yaoXiang2: "【象】：幹母之蠱，得中道也。",
        yaoXiang3: "【象】：幹父之蠱，終无咎也。",
        yaoXiang4: "【象】：裕父之蠱，往未得也。",
        yaoXiang5: "【象】：幹父用譽，承以德也。",
        yaoXiang6: "【象】：不事王侯，志可則也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "19",
        code : "110000",
        book : "上經", 
        name: "臨",
        fullName: "地澤臨",
        gua: "【卦辭】：臨，元亨利貞，至于八月有凶。",
        tuan: "【彖】：臨，剛浸而長，說而順，剛中而應，大亨以正，天之道也；至于八月有凶，消不久也。",
        xiang: "【象】：澤上有地，臨。君子以教思无窮，容保民无疆。",
        yao1: "【初九】：咸臨，貞吉。",
        yao2: "【九二】：咸臨，吉，无不利。",
        yao3: "【六三】：甘臨，无攸利。既憂之，无咎。",
        yao4: "【六四】：至臨，无咎。",
        yao5: "【六五】：知臨，大君之宜，吉。",
        yao6: "【上六】：敦臨，吉，无咎。",
        yaoXiang1: "【象】：咸臨貞吉，志行正也。",
        yaoXiang2: "【象】：咸臨吉无不利，未順命也。",
        yaoXiang3: "【象】：甘臨，位不當也，既憂之，咎不長也。",
        yaoXiang4: "【象】：至臨无咎，位當也。",
        yaoXiang5: "【象】：大君之宜，行中之謂也。",
        yaoXiang6: "【象】：敦臨之吉，志在內也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "20",
        code : "000011",
        book : "上經", 
        name: "觀",
        fullName: "風地觀",
        gua: "【卦辭】：觀，盥而不薦，有孚顒若。",
        tuan: "【彖】：大觀在上，順而巽，中正以觀天下。觀盥而不薦，有孚顒若，下觀而化也。觀天之神道，而四時不忒，聖人以神道設教，而天下服矣。",
        xiang: "【象】：風行地上，觀，先王以省方，觀民設教。",
        yao1: "【初六】：童觀，小人无咎，君子吝。",
        yao2: "【六二】：闚觀，利女貞。",
        yao3: "【六三】：觀我生，進退。",
        yao4: "【六四】：觀國之光，利用賓于王。",
        yao5: "【九五】：觀我生，君子无咎。",
        yao6: "【上九】：觀其生，君子无咎。",
        yaoXiang1: "【象】：初六童觀，小人道也。",
        yaoXiang2: "【象】：闚觀女貞，亦可醜也。",
        yaoXiang3: "【象】：觀我生進退，未失道也。",
        yaoXiang4: "【象】：觀國之光，尚賓也。",
        yaoXiang5: "【象】：觀我生，觀民也。",
        yaoXiang6: "【象】：觀其生，志未平也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "21",
        code : "100101",
        book : "上經", 
        name: "噬嗑",
        fullName: "火雷噬嗑",
        gua: "【卦辭】：噬嗑，亨，利用獄。",
        tuan: "【彖】：頤中有物，曰噬嗑。噬嗑而亨，剛柔分動而明，雷電合而章，柔得中而上行，雖不當位，利用獄也。",
        xiang: "【象】：雷電，噬嗑，先王以明罰敕法。",
        yao1: "【初九】：屨校滅趾，无咎。",
        yao2: "【六二】：噬膚，滅鼻，无咎。",
        yao3: "【六三】：噬腊肉，遇毒。小吝无咎。",
        yao4: "【九四】：噬乾胏，得金矢，利艱貞吉。",
        yao5: "【六五】：噬乾肉，得黃金，貞厲无咎。",
        yao6: "【上九】：何校滅耳，凶。",
        yaoXiang1: "【象】：屨校滅趾，不行也。",
        yaoXiang2: "【象】：噬膚滅鼻，乘剛也。",
        yaoXiang3: "【象】：遇毒，位不當也。",
        yaoXiang4: "【象】：利艱貞吉，未光也。",
        yaoXiang5: "【象】：貞厲无咎，得當也。",
        yaoXiang6: "【象】：何校滅耳，聰不明也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "22",
        code : "101001",
        book : "上經", 
        name: "賁卦",
        fullName: "山火賁",
        gua: "【卦辭】：賁亨，小利有攸往。",
        tuan: "【彖】：賁亨。柔來而文剛，故亨。分剛上而文柔，故小利有攸往，天文也。文明以止，人文也。觀乎天文，以察時變，觀乎人文，以化成天下。",
        xiang: "【象】：山下有火，賁。君子以明庶政，无敢折獄。",
        yao1: "【初九】：賁其趾，舍車而徒。",
        yao2: "【六二】：賁其須。",
        yao3: "【九三】：賁如濡如，永貞吉。",
        yao4: "【六四】：賁如皤如，白馬翰如，匪寇婚媾。",
        yao5: "【六五】：賁于丘園，束帛戔戔。吝，終吉。",
        yao6: "【上九】：白賁，无咎。",
        yaoXiang1: "【象】：舍車而徒，義弗乘也。",
        yaoXiang2: "【象】：賁其須，與上興也。",
        yaoXiang3: "【象】：永貞之吉，終莫之陵也。",
        yaoXiang4: "【象】：六四當位，疑也；匪寇婚媾，終无尤也。",
        yaoXiang5: "【象】：六五之吉，有喜也。",
        yaoXiang6: "【象】：白賁无咎，上得志也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "23",
        code : "000001",
        book : "上經", 
        name: "剝卦",
        fullName: "山地剝",
        gua: "【卦辭】：剝，不利有攸往。",
        tuan: "【彖】：剝，剝也，柔變剛也。不利有攸往，小人長也。順而止之，觀象也。君子尚消息盈虛，天行也。",
        xiang: "【象】：山附于地，剝，上以厚下安宅。",
        yao1: "【初六】：剝床以足，蔑貞凶。",
        yao2: "【六二】：剝床以辨，蔑貞凶。",
        yao3: "【六三】：剝之无咎。",
        yao4: "【六四】：剝床以膚，凶。",
        yao5: "【六五】：貫魚以宮人寵，无不利。",
        yao6: "【上九】：碩果不食，君子得輿，小人剝廬。",
        yaoXiang1: "【象】：剝床以足，以滅下也。",
        yaoXiang2: "【象】：剝床以辨，未有與也。",
        yaoXiang3: "【象】：剝之无咎，失上下也。",
        yaoXiang4: "【象】：剝床以膚，切近災也。",
        yaoXiang5: "【象】：以宮人寵，終无尤也。",
        yaoXiang6: "【象】：君子得輿，民所載也，小人剝廬，終不可用也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "24",
        code : "100000",
        book : "上經", 
        name: "復",
        fullName: "地雷復",
        gua: "【卦辭】：復，亨。出入无疾，朋來无咎。反復其道，七日來復，利有攸往。",
        tuan: "【彖】：復，亨。剛反，動而以順行，是以出入无疾，朋來无咎，反復其道，七日來復，天行也。利有攸往，剛長也。復，其見天地之心乎。",
        xiang: "【象】：雷在地中，復，先王以至日閉關，商旅不行，后不省方。",
        yao1: "【初九】：不遠復，无祇悔，元吉。",
        yao2: "【六二】：休復，吉。",
        yao3: "【六三】：頻復，厲，无咎。",
        yao4: "【六四】：中行獨復。",
        yao5: "【六五】：敦復，无悔。",
        yao6: "【上六】：迷復，凶，有災眚，用行師，終有大敗。以其國君，凶。至于十年不克征。",
        yaoXiang1: "【象】：不遠之復，以脩身也。",
        yaoXiang2: "【象】：休復之吉，以下仁也。",
        yaoXiang3: "【象】：頻復之厲，義无咎也。",
        yaoXiang4: "【象】：中行獨復，以從道也。",
        yaoXiang5: "【象】：敦復无悔，中以自考也。",
        yaoXiang6: "【象】：迷復之凶，反君道也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "25",
        code : "100111",
        book : "上經", 
        name: "无妄",
        fullName: "天雷无妄",
        gua: "【卦辭】：无妄，元亨利貞。其匪正有眚，不利有攸往。",
        tuan: "【彖】：无妄，剛自外來而為主於內，動而健，剛中而應，大亨以正，天之命也，其匪正有眚，不利有攸往。无妄之往，何之矣。天命不祐，行矣哉。",
        xiang: "【象】：天下雷行，物與无妄。先王以茂對，時育萬物。",
        yao1: "【初九】：无妄往，吉。",
        yao2: "【六二】：不耕穫，不菑畬，則利有攸往。",
        yao3: "【六三】：无妄之災，或繫之牛，行人之得，邑人之災。",
        yao4: "【九四】：可貞，无咎。",
        yao5: "【九五】：无妄之疾，勿藥有喜。",
        yao6: "【上九】：无妄行，有眚，无攸利。",
        yaoXiang1: "【象】：无妄之往，得志也。",
        yaoXiang2: "【象】：不耕穫，未富也。",
        yaoXiang3: "【象】：行人得牛，邑人災也。",
        yaoXiang4: "【象】：可貞无咎，固有之也。",
        yaoXiang5: "【象】：无妄之藥，不可試也。",
        yaoXiang6: "【象】：无妄之行，窮之災也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "26",
        code : "111001",
        book : "上經", 
        name: "大畜",
        fullName: "山天大畜",
        gua: "【卦辭】：大畜，利貞，不家食吉，利涉大川。",
        tuan: "【彖】：大畜，剛健篤實，輝光日新其德，剛上而尚賢，能止健，大正也。不家食吉，養賢也；利涉大川，應乎天也。",
        xiang: "【象】：天在山中，大畜。君子以多識前言往行，以畜其德。",
        yao1: "【初九】：有厲，利已。",
        yao2: "【九二】：輿說輹。",
        yao3: "【九三】：良馬逐，利艱貞。曰閑輿衛，利有攸往。",
        yao4: "【六四】：童牛之牿，元吉。",
        yao5: "【六五】：豶豕之牙，吉。",
        yao6: "【上九】：何天之衢，亨。",
        yaoXiang1: "【象】：有厲利已，不犯災也。",
        yaoXiang2: "【象】：輿說輹，中无尤也。",
        yaoXiang3: "【象】：利有攸往，上合志也。",
        yaoXiang4: "【象】：六四元吉，有喜也。",
        yaoXiang5: "【象】：六五之吉，有慶也。",
        yaoXiang6: "【象】：何天之衢，道大行也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "27",
        code : "100001",
        book : "上經", 
        name: "頤",
        fullName: "山雷頤",
        gua: "【卦辭】：頤，貞吉，觀頤，自求口實。",
        tuan: "【彖】：頤，貞吉，養正則吉也。觀頤，觀其所養也；自求口實，觀其自養也。天地養萬物，聖人養賢以及萬民，頤之時大矣哉。",
        xiang: "【象】：山下有雷，頤，君子以慎言語，節飲食。",
        yao1: "【初九】：舍爾靈龜，觀我朵頤，凶。",
        yao2: "【六二】：顛頤，拂經。于丘頤，征凶。",
        yao3: "【六三】：拂頤，貞凶。十年勿用，无攸利。",
        yao4: "【六四】：顛頤，吉，虎視眈眈，其欲逐逐，无咎。",
        yao5: "【六五】：拂經，居貞吉，不可涉大川。",
        yao6: "【上九】：由頤，厲吉，利涉大川。",
        yaoXiang1: "【象】：觀我朵頤，亦不足貴也。",
        yaoXiang2: "【象】：六二征凶，行失類也。",
        yaoXiang3: "【象】：十年勿用，道大悖也。",
        yaoXiang4: "【象】：顛頤之吉，上施光也。",
        yaoXiang5: "【象】：居貞之吉，順以從上也。",
        yaoXiang6: "【象】：由頤厲吉，大有慶也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "28",
        code : "011110",
        book : "上經", 
        name: "大過",
        fullName: "澤風大過",
        gua: "【卦辭】：大過，棟橈。利有攸往，亨。",
        tuan: "【彖】：大過，大者過也。棟橈，本末弱也。剛過而中，巽而說行，利有攸往，乃亨，大過之時大矣哉。",
        xiang: "【象】：澤滅木，大過。君子以獨立不懼，遯世无悶。",
        yao1: "【初六】：藉用白茅，无咎。",
        yao2: "【九二】：枯楊生稊，老夫得其女妻，无不利。",
        yao3: "【九三】：棟橈，凶。",
        yao4: "【九四】：棟隆，吉，有它吝。",
        yao5: "【九五】：枯楊生華，老婦得其士夫，无咎无譽。",
        yao6: "【上六】：過涉滅頂，凶，无咎。",
        yaoXiang1: "【象】：藉用白茅，柔在下也。",
        yaoXiang2: "【象】：老夫女妻，過以相與也。",
        yaoXiang3: "【象】：棟橈之凶，不可以有輔也。",
        yaoXiang4: "【象】：棟隆之吉，不橈乎下也。",
        yaoXiang5: "【象】：枯楊生華，何可久也；老婦士夫，亦可醜也。",
        yaoXiang6: "【象】：過涉之凶，不可咎也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "29",
        code : "010010",
        book : "上經", 
        name: "坎",
        fullName: "坎為水",
        gua: "【卦辭】：習坎，有孚，維心亨，行有尚。",
        tuan: "【彖】：習坎，重險也。水流而不盈，行險而不失其信。維心亨，乃以剛中也；行有尚，往有功也。天險不可升也，地險山川丘陵也，王公設險以守其國，險之時用大矣哉。",
        xiang: "【象】：水洊至，習坎。君子以常德行，習教事。",
        yao1: "【初六】：習坎，入于坎窞，凶。",
        yao2: "【九二】：坎，有險，求小得。",
        yao3: "【六三】：來之坎坎，險且枕，入于坎窞，勿用。",
        yao4: "【六四】：樽酒，簋貳，用缶，納約自牖，終无咎。",
        yao5: "【九五】：坎不盈，祗既平，无咎。",
        yao6: "【上六】：係用黴纆，寘于叢棘，三歲不得，凶。",
        yaoXiang1: "【象】：習坎入坎，失道凶也。",
        yaoXiang2: "【象】：求小得，未出中也。",
        yaoXiang3: "【象】：來之坎坎，終无功也。",
        yaoXiang4: "【象】：樽酒簋貳，剛柔際也。",
        yaoXiang5: "【象】：坎不盈，中未大也。",
        yaoXiang6: "【象】：上六失道，凶三歲也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "30",
        code : "101101",
        book : "上經", 
        name: "離",
        fullName: "離為火",
        gua: "【卦辭】：離，利貞，亨，畜牝牛，吉。",
        tuan: "【彖】：離，麗也。日月麗乎天，百穀草木麗乎土，重明以麗乎正，乃化成天下。柔麗乎中正，故亨，是以畜牝牛吉也。",
        xiang: "【象】：明兩作，離，大人以繼明照于四方。",
        yao1: "【初九】：履錯然，敬之，无咎。",
        yao2: "【六二】：黃離，元吉。",
        yao3: "【九三】：日昃之離，不鼓缶而歌，則大耋之嗟，凶。",
        yao4: "【九四】：突如其來如，焚如，死如，棄如。",
        yao5: "【六五】：出涕沱若，戚嗟若，吉。",
        yao6: "【上九】：王用出征，有嘉折首，獲匪其醜，无咎。",
        yaoXiang1: "【象】：履錯之敬，以辟咎也。",
        yaoXiang2: "【象】：黃離元吉，得中道也。",
        yaoXiang3: "【象】：日昃之離，何可久也。",
        yaoXiang4: "【象】：突如其來如，无所容也。",
        yaoXiang5: "【象】：六五之吉，離王公也。",
        yaoXiang6: "【象】：王用出征，以正邦也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "31",
        code : "001110",
        book : "下經", 
        name: "咸",
        fullName: "澤山咸",
        gua: "【卦辭】：咸亨，利貞，取女吉。",
        tuan: "【彖】：咸，感也。柔上而剛下，二氣感應以相與，止而說，男下女，是以亨，利貞，取女吉也。天地感而萬物化生，聖人感人心而天下和平。觀其所感，而天地萬物之情可見矣。",
        xiang: "【象】：山上有澤，咸，君子以虛受人。",
        yao1: "【初六】：咸其拇。",
        yao2: "【六二】：咸其腓，凶，居吉。",
        yao3: "【九三】：咸其股，執其隨，往吝。",
        yao4: "【九四】：貞吉，悔亡，憧憧往來，朋從爾思。",
        yao5: "【九五】：咸其脢，无悔。",
        yao6: "【上六】：咸其輔頰舌。",
        yaoXiang1: "【象】：咸其拇，志在外也。",
        yaoXiang2: "【象】：雖凶居吉，順不害也。",
        yaoXiang3: "【象】：咸其股，亦不處也。志在隨人，所執下也。",
        yaoXiang4: "【象】：貞吉悔亡，未感害也；憧憧往來，未光大也。",
        yaoXiang5: "【象】：咸其脢，志末也。",
        yaoXiang6: "【象】：咸其輔頰舌，滕口說也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "32",
        code : "011100",
        book : "下經", 
        name: "恒",
        fullName: "雷風恒",
        gua: "【卦辭】：恒，亨，无咎，利貞，利有攸往。",
        tuan: "【彖】：恒，久也。剛上而柔下，雷風相與，巽而動，剛柔皆應，恒。恒，亨，无咎，利貞，久於其道也。天地之道，恒久而不已也，利有攸往，終則有始也，日月得天而能久照，四時變化而能久成，聖人久於其道而天下化成，觀其所恒而天地萬物之情可見矣。",
        xiang: "【象】：雷風，恒，君子以立不易方。",
        yao1: "【初六】：浚恒，貞凶，无攸利。",
        yao2: "【九二】：悔亡。",
        yao3: "【九三】：不恒其德，或承之羞，貞吝。",
        yao4: "【九四】：田无禽。",
        yao5: "【六五】：恒其德貞，婦人吉，夫子凶。",
        yao6: "【上六】：振恒，凶。",
        yaoXiang1: "【象】：浚恒之凶，始求深也。",
        yaoXiang2: "【象】：九二悔亡，能久中也。",
        yaoXiang3: "【【象】：不恒其德，无所容也。",
        yaoXiang4: "【象】：久非其位，安得禽也。",
        yaoXiang5: "【象】：婦人貞吉，從一而終也。夫子制義，從婦凶也。",
        yaoXiang6: "【象】：振恒在上，大无功也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "33",
        code : "001111",
        book : "下經", 
        name: "遯",
        fullName: "天山遯",
        gua: "【卦辭】：遯亨，小利貞。",
        tuan: "【彖】：遯亨，遯而亨也。剛當位而應，與時行也。小利貞，浸而長也。遯之時義大矣哉。",
        xiang: "【象】：天下有山，遯。君子以遠小人，不惡而嚴。",
        yao1: "【初六】：遯尾，厲。勿用有攸往。",
        yao2: "【六二】：執之用黃牛之革，莫之勝說。",
        yao3: "【九三】：係遯，有疾厲，畜臣妾吉。",
        yao4: "【九四】：好遯，君子吉，小人否。",
        yao5: "【九五】：嘉遯，貞吉。",
        yao6: "【上九】：肥遯，无不利。",
        yaoXiang1: "【象】：遯尾之厲，不往何災也。",
        yaoXiang2: "【象】：執用黃牛，固志也。",
        yaoXiang3: "【象】：係遯之厲，有疾憊也。畜臣妾吉，不可大事也。",
        yaoXiang4: "【象】：君子好遯，小人否也。",
        yaoXiang5: "【象】：嘉遯貞吉，以正志也。",
        yaoXiang6: "【象】：肥遯，无不利，无所疑也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "34",
        code : "111100",
        book : "下經", 
        name: "大壯",
        fullName: "雷天大壯",
        gua: "【卦辭】：大壯，利貞。",
        tuan: "【彖】：大壯，大者壯也，剛以動，故壯。大壯利貞，大者正也。正大而天地之情可見矣。",
        xiang: "【象】：雷在天上，大壯，君子以非禮弗履。",
        yao1: "【初九】：壯于趾，征凶，有孚。",
        yao2: "【九二】：貞吉。",
        yao3: "【九三】：小人用壯，君子用罔。貞厲，羝羊觸藩，羸其角。",
        yao4: "【九四】：貞吉，悔亡，藩決不羸，壯于大輿之輹。",
        yao5: "【六五】：喪羊于易，无悔。",
        yao6: "【上六】：羝羊觸藩，不能退，不能遂，无攸利，艱則吉。",
        yaoXiang1: "【象】：壯于趾，其孚窮也。",
        yaoXiang2: "【象】：九二貞吉，以中也。",
        yaoXiang3: "【象】：小人用壯，君子罔也。",
        yaoXiang4: "【象】：藩決不羸，尚往也。",
        yaoXiang5: "【象】：喪羊于易，位不當也。",
        yaoXiang6: "【象】：不能退，不能遂，不詳也。艱則吉，咎不長也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "35",
        code : "000101",
        book : "下經", 
        name: "晉",
        fullName: "火地晉",
        gua: "【卦辭】：晉，康侯用錫馬蕃庶，晝日三接。",
        tuan: "【彖】：晉，進也。明出地上，順而麗乎大明，柔進而上行，是以康侯用錫馬蕃庶，晝日三接也。",
        xiang: "【象】：明出地上，晉。君子以自昭明德。",
        yao1: "【初六】：晉如摧如，貞吉。罔孚裕，无咎。",
        yao2: "【六二】：晉如愁如，貞吉。受茲介福，于其王母。",
        yao3: "【六三】：眾允，悔亡。",
        yao4: "【九四】：晉如鼫鼠，貞厲。",
        yao5: "【六五】：悔亡，失得勿恤。往吉无不利。",
        yao6: "【上九】：晉其角，維用伐邑。厲吉无咎，貞吝。",
        yaoXiang1: "【象】：晉如摧如，獨行正也；裕无咎，未受命也。",
        yaoXiang2: "【象】：受茲介福，以中正也。",
        yaoXiang3: "【象】：眾允之，志上行也。",
        yaoXiang4: "【象】：鼫鼠貞厲，位不當也。",
        yaoXiang5: "【象】：失得勿恤，往有慶也。",
        yaoXiang6: "【象】：維用伐邑，道未光也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "36",
        code : "101000",
        book : "下經", 
        name: "明夷",
        fullName: "地火明夷",
        gua: "【卦辭】：明夷，利艱貞。",
        tuan: "【彖】：明入地中，明夷。內文明而外柔順，以蒙大難，文王以之。利艱貞，晦其明也。內難而能正其志，箕子以之。",
        xiang: "【象】：明入地中，明夷。君子以莅眾，用晦而明。",
        yao1: "【初九】：明夷于飛，垂其翼。君子于行，三日不食。有攸往，主人有言。",
        yao2: "【六二】：明夷，夷于左股，用拯馬壯吉。",
        yao3: "【九三】：明夷于南狩，得其大首，不可疾貞。",
        yao4: "【六四】：入于左腹，獲明夷之心，于出門庭。",
        yao5: "【六五】：箕子之明夷，利貞。",
        yao6: "【上六】：不明晦，初登于天，後入于地。",
        yaoXiang1: "【象】：君子于行，義不食也。",
        yaoXiang2: "【象】：六二之吉，順以則也。",
        yaoXiang3: "【象】：南狩之志，乃得大也。",
        yaoXiang4: "【象】：入于左腹，獲心意也。",
        yaoXiang5: "【象】：箕子之貞，明不可息也。",
        yaoXiang6: "【象】：初登于天，照四國也；後入于地，失則也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "37",
        code : "101011",
        book : "下經", 
        name: "家人",
        fullName: "風火家人",
        gua: "【卦辭】：家人，利女貞。",
        tuan: "【彖】：家人，女正位乎內，男正位乎外，男女正，天地之大義也。家人有嚴君焉，父母之謂也。父父，子子，兄兄，弟弟，夫夫，婦婦，而家道正。正家，而天下定矣。",
        xiang: "【象】：風自火出，家人，君子以言有物，而行有恆。",
        yao1: "【初九】：閑有家，悔亡。",
        yao2: "【六二】：无攸遂，在中饋，貞吉。",
        yao3: "【九三】：家人嗃嗃，悔厲吉，婦子嘻嘻，終吝。",
        yao4: "【六四】：富家，大吉。",
        yao5: "【九五】：王假有家，勿恤，吉。",
        yao6: "【上九】：有孚，威如，終吉。",
        yaoXiang1: "【象】：閑有家，志未變也。",
        yaoXiang2: "【象】：六二之吉，順以巽也。",
        yaoXiang3: "【象】：家人嗃嗃，未失也。婦子嘻嘻，失家節也。",
        yaoXiang4: "【象】：富家大吉，順在位也。",
        yaoXiang5: "【象】：王假有家，交相愛也。",
        yaoXiang6: "【象】：威如之吉，反身之謂也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "38",
        code : "110101",
        book : "下經", 
        name: "睽",
        fullName: "火澤睽",
        gua: "【卦辭】：睽，小事吉。",
        tuan: "【彖】：睽，火動而上，澤動而下，二女同居，其志不同行。說而麗乎明，柔進而上行，得中而應乎剛，是以小事吉。天地睽而其事同也，男女睽而其志通也，萬物睽而其事類也，睽之時用大矣哉。",
        xiang: "【象】：上火下澤，睽，君子以同而異。",
        yao1: "【初九】：悔亡，喪馬勿逐，自復。見惡人，无咎。",
        yao2: "【九二】：遇主于巷，无咎。",
        yao3: "【六三】：見輿曳，其牛掣，其人天且劓，无初有終。",
        yao4: "【九四】：睽孤，遇元夫。交孚，厲无咎。",
        yao5: "【六五】：悔亡。厥宗噬膚，往何咎。",
        yao6: "【上九】：睽孤，見豕負塗，載鬼一車，先張之弧，後說之弧，匪寇婚媾。往，遇雨則吉。",
        yaoXiang1: "【象】：見惡人，以辟咎也。",
        yaoXiang2: "【象】：遇主于巷，未失道也。",
        yaoXiang3: "【象】：見輿曳，位不當也。无初有終，遇剛也。",
        yaoXiang4: "【象】：交孚无咎，志行也。",
        yaoXiang5: "【象】：厥宗噬膚，往有慶也。",
        yaoXiang6: "【象】：遇雨之吉，群疑亡也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "39",
        code : "001010",
        book : "下經", 
        name: "蹇",
        fullName: "水山蹇",
        gua: "【卦辭】：蹇，利西南，不利東北，利見大人，貞吉。",
        tuan: "【彖】：蹇，難也，險在前也。見險而能止，知矣哉。蹇，利西南，往得中也；不利東北，其道窮也。利見大人，往有功也；當位貞吉，以正邦也。蹇之時用大矣哉。",
        xiang: "【象】：山上有水，蹇，君子以反身脩德。",
        yao1: "【初六】：往蹇來譽。",
        yao2: "【六二】：王臣蹇蹇，匪躬之故。",
        yao3: "【九三】：往蹇來反。",
        yao4: "【六四】：往蹇來連。",
        yao5: "【九五】：大蹇朋來。",
        yao6: "【上六】：往蹇來碩，吉，利見大人。",
        yaoXiang1: "【象】：往蹇來譽，宜待也。",
        yaoXiang2: "【象】：王臣蹇蹇，終无尤也。",
        yaoXiang3: "【象】：往蹇來反，內喜之也。",
        yaoXiang4: "【象】：往蹇來連，當位實也。",
        yaoXiang5: "【象】：大蹇朋來，以中節也。",
        yaoXiang6: "【象】：往蹇來碩，志在內也；利見大人，以從貴也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "40",
        code : "010100",
        book : "下經", 
        name: "解",
        fullName: "雷水解",
        gua: "【卦辭】：解，利西南，无所往，其來復吉；有攸往，夙吉。",
        tuan: "【彖】：解，險以動，動而免乎險，解。解，利西南，往得眾也；其來復吉，乃得中也；有攸往夙吉，往有功也。天地解而雷雨作，雷雨作而百果草木皆甲坼，解之時大矣哉。",
        xiang: "【象】：雷雨作，解。君子以赦過宥罪。",
        yao1: "【初六】：无咎。",
        yao2: "【九二】：田獲三狐，得黃矢，貞吉。",
        yao3: "【六三】：負且乘，致寇至，貞吝。",
        yao4: "【九四】：解而拇，朋至斯孚。",
        yao5: "【六五】：君子維有解，吉，有孚于小人。",
        yao6: "【上六】：公用射隼于高墉之上，獲之，无不利。",
        yaoXiang1: "【象】：剛柔之際，義无咎也。",
        yaoXiang2: "【象】：九二貞吉，得中道也。",
        yaoXiang3: "【象】：負且乘，亦可醜也，自我致戎，又誰咎也。",
        yaoXiang4: "【象】：解而拇，未當位也。",
        yaoXiang5: "【象】：君子有解，小人退也。",
        yaoXiang6: "【象】：公用射隼，以解悖也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "41",
        code : "110001",
        book : "下經", 
        name: "損",
        fullName: "山澤損",
        gua: "【卦辭】：損，有孚，元吉，无咎可貞，利有攸往。曷之用，二簋可用享。",
        tuan: "【彖】：損，損下益上，其道上行，損而有孚，元吉。无咎，可貞，利有攸往，曷之用，二簋可用享，二簋應有時，損剛益柔有時，損益盈虛，與時偕行。",
        xiang: "【象】：山下有澤，損，君子以懲忿窒欲。",
        yao1: "【初九】：已事遄往，无咎，酌損之。",
        yao2: "【九二】：利貞，征凶。弗損，益之。",
        yao3: "【六三】：三人行，則損一人，一人行，則得其友。",
        yao4: "【六四】：損其疾，使遄有喜，无咎。",
        yao5: "【六五】：或益之十朋之龜，弗克違，元吉。",
        yao6: "【上九】：弗損，益之，无咎，貞吉，利有攸往，得臣无家。",
        yaoXiang1: "【象】：已事遄往，尚合志也。",
        yaoXiang2: "【象】：九二利貞，中以為志也。",
        yaoXiang3: "【象】：一人行，三則疑也。",
        yaoXiang4: "【象】：損其疾，亦可喜也。",
        yaoXiang5: "【象】：六五元吉，自上祐也。",
        yaoXiang6: "【象】：弗損益之，大得志也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "42",
        code : "100011",
        book : "下經", 
        name: "益",
        fullName: "風雷益",
        gua: "【卦辭】：益，利有攸往，利涉大川。",
        tuan: "【彖】：益，損上益下，民說无疆，自上下下，其道大光。利有攸往，中正有慶；利涉大川，木道乃行。益動而巽，日進无疆，天施地生，其益无方，凡益之道，與時偕行。",
        xiang: "【象】：風雷，益，君子以見善則遷，有過則改。",
        yao1: "【初九】：利用為大作，元吉，无咎。",
        yao2: "【六二】：或益之十朋之龜，弗克違，永貞吉。王用享于帝，吉。",
        yao3: "【六三】：益之用凶事，无咎。有孚中行，告公用圭。",
        yao4: "【六四】：中行，告公從，利用為依遷國。",
        yao5: "【九五】：有孚惠心，勿問元吉。有孚惠我德。",
        yao6: "【上九】：莫益之，或擊之，立心勿恒，凶。",
        yaoXiang1: "【象】：元吉无咎，下不厚事也。",
        yaoXiang2: "【象】：或益之，自外來也。",
        yaoXiang3: "【象】：益用凶事，固有之也。",
        yaoXiang4: "【象】：告公從，以益志也。",
        yaoXiang5: "【象】：有孚惠心，勿問之矣；惠我德，大得志也。",
        yaoXiang6: "【象】：莫益之，偏辭也；或擊之，自外來也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "43",
        code : "111110",
        book : "下經", 
        name: "夬",
        fullName: "澤天夬",
        gua: "【卦辭】：夬，揚于王庭，孚號有厲。告自邑，不利即戎，利有攸往。",
        tuan: "【彖】：夬，決也，剛決柔也。健而說，決而和。揚于王庭，柔乘五剛也；孚號有厲，其危乃光也；告自邑，不利即戎，所尚乃窮也；利有攸往，剛長乃終也。",
        xiang: "【象】：澤上於天，夬。君子以施祿及下，居德則忌。",
        yao1: "【初九】：壯于前趾，往不勝為咎。",
        yao2: "【九二】：惕號，莫夜有戎，勿恤。",
        yao3: "【九三】：壯于頄，有凶。君子夬夬，獨行，遇雨若濡。有慍无咎。",
        yao4: "【九四】：臀无膚，其行次且，牽羊悔亡，聞言不信。",
        yao5: "【九五】：莧陸夬夬，中行无咎。",
        yao6: "【上六】：无號，終有凶。",
        yaoXiang1: "【象】：不勝而往，咎也。",
        yaoXiang2: "【象】：有戎勿恤，得中道也。",
        yaoXiang3: "【象】：君子夬夬，終无咎也。",
        yaoXiang4: "【象】：其行次且，位不當也，聞言不信，聰不明也。",
        yaoXiang5: "【象】：中行无咎，中未光也。",
        yaoXiang6: "【象】：无號之凶，終不可長也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "44",
        code : "011111",
        book : "下經", 
        name: "姤",
        fullName: "天風姤",
        gua: "【卦辭】：姤，女壯，勿用取女。",
        tuan: "【彖】：姤，遇也，柔遇剛也。勿用取女，不可與長也。天地相遇，品物咸章也；剛遇中正，天下大行也，姤之時義大矣哉。",
        xiang: "【象】：天下有風，姤，后以施命誥四方。",
        yao1: "【初六】：繫于金柅，貞吉。有攸往，見凶。羸豕孚蹢躅。",
        yao2: "【九二】：包有魚，无咎，不利賓。",
        yao3: "【九三】：臀无膚，其行次且，厲，无大咎。",
        yao4: "【九四】：包无魚，起凶。",
        yao5: "【九五】：以杞包瓜，含章，有隕自天。",
        yao6: "【上九】：姤其角，吝，无咎。",
        yaoXiang1: "【象】：繫于金柅，柔道牽也。",
        yaoXiang2: "【象】：包有魚，義不及賓也。",
        yaoXiang3: "【象】：其行次且，行未牽也。",
        yaoXiang4: "【象】：无魚之凶，遠民也。",
        yaoXiang5: "【象】：九五含章，中正也。有隕自天，志不舍命也。",
        yaoXiang6: "【象】：姤其角，上窮吝也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "45",
        code : "000110",
        book : "下經", 
        name: "萃",
        fullName: "澤地萃",
        gua: "【卦辭】：萃亨，王假有廟，利見大人，亨，利貞。用大牲吉。利有攸往。",
        tuan: "【彖】：萃，聚也。順以說，剛中而應，故聚也。王假有廟，致孝享也；利見大人，亨，聚以正也；用大牲，吉，利有攸往，順天命也。觀其所聚，而天地萬物之情可見矣。",
        xiang: "【象】：澤上於地，萃，君子以除戎器，戒不虞。",
        yao1: "【初六】：有孚不終，乃亂乃萃，若號。一握為笑，勿恤，往无咎。",
        yao2: "【六二】：引吉，无咎，孚乃利用禴。",
        yao3: "【六三】：萃如嗟如，无攸利。往无咎，小吝。",
        yao4: "【九四】：大吉，无咎。",
        yao5: "【九五】：萃有位，无咎，匪孚。元永貞，悔亡。",
        yao6: "【上六】：齎咨涕洟，无咎。",
        yaoXiang1: "【象】：乃亂乃萃，其志亂也。",
        yaoXiang2: "【象】：引吉无咎，中未變也。",
        yaoXiang3: "【象】：往无咎，上巽也。",
        yaoXiang4: "【象】：大吉无咎，位不當也。",
        yaoXiang5: "【象】：萃有位，志未光也。",
        yaoXiang6: "【象】：齎咨涕洟，未安上也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "46",
        code : "011000",
        book : "下經", 
        name: "升",
        fullName: "地風升",
        gua: "【卦辭】：升，元亨。用見大人，勿恤。南征吉。",
        tuan: "【彖】：柔以時升，巽而順，剛中而應，是以大亨；用見大人，勿恤，有慶也；南征吉，志行也。",
        xiang: "【象】：地中生木，升。君子以順德，積小以高大。",
        yao1: "【初六】：允升，大吉。",
        yao2: "【九二】：孚乃利用禴，无咎。",
        yao3: "【九三】：升虛邑。",
        yao4: "【六四】：王用亨于岐山，吉，无咎。",
        yao5: "【六五】：貞吉，升階。",
        yao6: "【上六】：冥升，利于不息之貞。",
        yaoXiang1: "【象】：允升大吉，上合志也。",
        yaoXiang2: "【象】：九二之孚，有喜也。",
        yaoXiang3: "【象】：升虛邑，无所疑也。",
        yaoXiang4: "【象】：王用亨于岐山，順事也。",
        yaoXiang5: "【象】：貞吉升階，大得志也。",
        yaoXiang6: "【象】：冥升在上，消不富也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "47",
        code : "010110",
        book : "下經", 
        name: "困",
        fullName: "澤水困",
        gua: "【卦辭】：困，亨，貞大人吉，无咎。有言不信。",
        tuan: "【彖】：困，剛揜也。險以說，困而不失其所亨，其唯君子乎。貞大人吉，以剛中也；有言不信，尚口乃窮也。",
        xiang: "【象】：澤无水，困。君子以致命遂志。",
        yao1: "【初六】：臀困于株木，入于幽谷，三歲不覿。",
        yao2: "【九二】：困于酒食，朱紱方來，利用享祀，征凶，无咎。",
        yao3: "【六三】：困于石，據于蒺蔾，入于其宮，不見其妻，凶。",
        yao4: "【九四】：來徐徐，困于金車。吝，有終。",
        yao5: "【九五】：劓刖，困于赤紱，乃徐有說。利用祭祀。",
        yao6: "【上六】：困于葛藟，于臲卼，曰動悔有悔，征吉。",
        yaoXiang1: "【象】：入于幽谷，幽不明也。",
        yaoXiang2: "【象】：困于酒食，中有慶也。",
        yaoXiang3: "【象】：據于蒺蔾，乘剛也。入于其宮，不見其妻，不祥也。",
        yaoXiang4: "【象】：來徐徐，志在下也。雖不當位，有與也。",
        yaoXiang5: "【象】：劓刖，志未得也；乃徐有說，以中直也；利用祭祀，受福也。",
        yaoXiang6: "【象】：困于葛藟，未當也；動悔有悔，吉行也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "48",
        code : "011010",
        book : "下經", 
        name: "井",
        fullName: "水風井",
        gua: "【卦辭】：井，改邑不改井，无喪无得，往來井井，汔至，亦未繘井，羸其瓶，凶。",
        tuan: "【彖】：巽乎水而上水，井，井養而不窮也。改邑不改井，乃以剛中也；汔至亦未繘井，未有功也；羸其瓶，是以凶也。",
        xiang: "【象】：木上有水，井，君子以勞民勸相。",
        yao1: "【初六】：井泥不食，舊井无禽。",
        yao2: "【九二】：井谷射鮒，甕敝漏。",
        yao3: "【九三】：井渫不食，為我心惻，可用汲。王明，並受其福。",
        yao4: "【六四】：井甃无咎。",
        yao5: "【九五】：井洌，寒泉食。",
        yao6: "【上六】：井收勿幕，有孚元吉。",
        yaoXiang1: "【象】：井泥不食，下也；舊井无禽，時舍也。",
        yaoXiang2: "【象】：井谷射鮒，无與也。",
        yaoXiang3: "【象】：井渫不食，行惻也；求王明，受福也。",
        yaoXiang4: "【象】：井甃无咎，脩井也。",
        yaoXiang5: "【象】：寒泉之食，中正也。",
        yaoXiang6: "【象】：元吉在上，大成也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "49",
        code : "101110",
        book : "下經", 
        name: "革",
        fullName: "澤火革",
        gua: "【卦辭】：革，已日乃孚，元亨利貞，悔亡。",
        tuan: "【彖】：革，水火相息，二女同居，其志不相得，曰革。已日乃孚，革而信之，文明以說，大亨以正，革而當，其悔乃亡。天地革而四時成，湯武革命，順乎天而應乎人，革之時大矣哉。",
        xiang: "【象】：澤中有火，革，君子以治曆明時。",
        yao1: "【初九】：鞏用黃牛之革。",
        yao2: "【六二】：已日乃革之，征吉，无咎。",
        yao3: "【九三】：征凶，貞厲，革言三就，有孚。",
        yao4: "【九四】：悔亡，有孚，改命吉。",
        yao5: "【九五】：大人虎變，未占有孚。",
        yao6: "【上六】：君子豹變，小人革面，征凶，居貞吉。",
        yaoXiang1: "【象】：鞏用黃牛，不可以有為也。",
        yaoXiang2: "【象】：已日革之，行有嘉也。",
        yaoXiang3: "【象】：革言三就，又何之矣。",
        yaoXiang4: "【象】：改命之吉，信志也。",
        yaoXiang5: "【象】：大人虎變，其文炳也。",
        yaoXiang6: "【象】：君子豹變，其文蔚也；小人革面，順以從君也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "50",
        code : "011101",
        book : "下經", 
        name: "鼎",
        fullName: "火風鼎",
        gua: "【卦辭】：鼎，元吉，亨。",
        tuan: "【彖】：鼎，象也。以木巽火，亨飪也。聖人亨以享上帝，而大亨以養聖賢。巽而耳目聰明，柔進而上行，得中而應乎剛，是以元亨。",
        xiang: "【象】：木上有火，鼎，君子以正位凝命。",
        yao1: "【初六】：鼎顛趾，利出否，得妾以其子，无咎。",
        yao2: "【九二】：鼎有實，我仇有疾，不我能即，吉。",
        yao3: "【九三】：鼎耳革，其行塞，雉膏不食。方雨虧悔，終吉。",
        yao4: "【九四】：鼎折足，覆公餗，其形渥，凶。",
        yao5: "【六五】：鼎黃耳金鉉，利貞。",
        yao6: "【上九】：鼎玉鉉，大吉，无不利。",
        yaoXiang1: "【象】：鼎顛趾，未悖也。利出否，以從貴也。",
        yaoXiang2: "【象】：鼎有實，慎所之也。我仇有疾，終无尤也。",
        yaoXiang3: "【象】：鼎耳革，失其義也。",
        yaoXiang4: "【象】：覆公餗，信如何也。",
        yaoXiang5: "【象】：鼎黃耳，中以為實也。",
        yaoXiang6: "【象】：玉鉉在上，剛柔節也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "51",
        code : "100100",
        book : "下經", 
        name: "震",
        fullName: "震為雷",
        gua: "【卦辭】：震，亨。震來虩虩，笑言啞啞，震驚百里，不喪匕鬯。",
        tuan: "【彖】：震，亨。震來虩虩，恐致福也；笑言啞啞，後有則也；震驚百里，驚遠而懼邇也，出可以守宗廟社稷，以為祭主也。",
        xiang: "【象】：洊雷震，君子以恐懼脩省。",
        yao1: "【初九】：震來虩虩，後笑言啞啞，吉。",
        yao2: "【六二】：震來厲，億喪貝，躋于九陵。勿逐，七日得。",
        yao3: "【六三】：震蘇蘇，震行无眚。",
        yao4: "【九四】：震遂泥。",
        yao5: "【六五】：震往來厲，億无喪，有事。",
        yao6: "【上六】：震索索，視矍矍，征凶。震不于其躬于其鄰，无咎。婚媾有言。",
        yaoXiang1: "【象】：震來虩虩，恐致福也；笑言啞啞，後有則也。",
        yaoXiang2: "【象】：震來厲，乘剛也。",
        yaoXiang3: "【象】：震蘇蘇，位不當也。",
        yaoXiang4: "【象】：震遂泥，未光也。",
        yaoXiang5: "【象】：震往來厲，危行也。其事在中，大无喪也。",
        yaoXiang6: "【象】：震索索，中未得也；雖凶无咎，畏鄰戒也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "52",
        code : "001001",
        book : "下經", 
        name: "艮",
        fullName: "艮為山",
        gua: "【卦辭】：艮其背，不獲其身；行其庭，不見其人。无咎。",
        tuan: "【彖】：艮，止也，時止則止，時行則行，動靜不失其時，其道光明。艮其止，止其所也。上下敵應，不相與也，是以不獲其身。行其庭不見其人，无咎也。",
        xiang: "【象】：兼山，艮，君子以思不出其位。",
        yao1: "【初六】：艮其趾，无咎，利永貞。",
        yao2: "【六二】：艮其腓，不拯其隨，其心不快。",
        yao3: "【九三】：艮其限，列其夤，厲薰心。",
        yao4: "【六四】：艮其身，无咎。",
        yao5: "【六五】：艮其輔，言有序，悔亡。",
        yao6: "【上九】：敦艮，吉。",
        yaoXiang1: "【象】：艮其趾，未失正也。",
        yaoXiang2: "【象】：不拯其隨，未退聽也。",
        yaoXiang3: "【象】：艮其限，危薰心也。",
        yaoXiang4: "【象】：艮其身，止諸躬也。",
        yaoXiang5: "【象】：艮其輔，以中正也。",
        yaoXiang6: "【象】：敦艮之吉，以厚終也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "53",
        code : "001011",
        book : "下經", 
        name: "漸",
        fullName: "風山漸",
        gua: "【卦辭】：漸，女歸吉，利貞。",
        tuan: "【彖】：漸之進也，女歸吉也。進得位，往有功也。進以正，可以正邦也。其位剛得中也。止而巽，動不窮也。",
        xiang: "【象】：山上有木，漸，君子以居賢德善俗。",
        yao1: "【初六】：鴻漸于干，小子厲，有言，无咎。",
        yao2: "【六二】：鴻漸于磐，飲食衎衎，吉。",
        yao3: "【九三】：鴻漸于陸，夫征不復，婦孕不育，凶，利禦寇。",
        yao4: "【六四】：鴻漸于木，或得其桷，无咎。",
        yao5: "【九五】：鴻漸于陵，婦三歲不孕，終莫之勝，吉。",
        yao6: "【上九】：鴻漸于陸，其羽可用為儀，吉。",
        yaoXiang1: "【象】：小子之厲，義无咎也。",
        yaoXiang2: "【象】：飲食衎衎，不素飽也。",
        yaoXiang3: "【象】：夫征不復，離群醜也；婦孕不育，失其道也；利用禦寇，順相保也。",
        yaoXiang4: "【象】：或得其桷，順以巽也。",
        yaoXiang5: "【象】：終莫之勝，吉，得所願也。",
        yaoXiang6: "【象】：其羽可用為儀，吉，不可亂也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "54",
        code : "110100",
        book : "下經", 
        name: "歸妹",
        fullName: "雷澤歸妹",
        gua: "【卦辭】：歸妹，征凶，无攸利。",
        tuan: "【彖】：歸妹，天地之大義也。天地不交，而萬物不興。歸妹，人之終始也，說以動，所歸妹也。征凶，位不當也；无攸利，柔乘剛也。",
        xiang: "【象】：澤上有雷，歸妹。君子以永終知敝。",
        yao1: "【初九】：歸妹以娣，跛能履，征吉。",
        yao2: "【九二】：眇能視，利幽人之貞。",
        yao3: "【六三】：歸妹以須，反歸以娣。",
        yao4: "【九四】：歸妹愆期，遲歸有時。",
        yao5: "【六五】：帝乙歸妹，其君之袂，不如其娣之袂良。月幾望，吉。",
        yao6: "【上六】：女承筐无實，士刲羊无血，无攸利。",
        yaoXiang1: "【象】：歸妹以娣，以恒也；跛能履，吉，相承也。",
        yaoXiang2: "【象】：利幽人之貞，未變常也。",
        yaoXiang3: "【象】：歸妹以須，未當也。",
        yaoXiang4: "【象】：愆期之志，有待而行也。",
        yaoXiang5: "【象】：帝乙歸妹，不如其娣之袂良也。其位在中，以貴行也。",
        yaoXiang6: "【象】：上六无實，承虛筐也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "55",
        code : "101100",
        book : "下經", 
        name: "豐",
        fullName: "雷火豐",
        gua: "【卦辭】：豐亨，王假之，勿憂，宜日中。",
        tuan: "【彖】：豐，大也。明以動，故豐。王假之，尚大也；勿憂，宜日中，宜照天下也。日中則昃，月盈則食，天地盈虛，與時消息，而況於人乎？況於鬼神乎？",
        xiang: "【象】：雷電皆至，豐，君子以折獄致刑。",
        yao1: "【初九】：遇其配主，雖旬无咎，往有尚。",
        yao2: "【六二】：豐其蔀，日中見斗。往得疑疾，有孚發若，吉。",
        yao3: "【九三】：豐其沛，日中見沬。折其右肱，无咎。",
        yao4: "【九四】：豐其蔀，日中見斗，遇其夷主，吉。",
        yao5: "【六五】：來章，有慶譽，吉。",
        yao6: "【上六】：豐其屋，蔀其家，闚其戶，闃其无人，三歲不覿，凶。",
        yaoXiang1: "【象】：雖旬无咎，過旬災也。",
        yaoXiang2: "【象】：有孚發若，信以發志也。",
        yaoXiang3: "【象】：豐其沛，不可大事也；折其右肱，終不可用也。",
        yaoXiang4: "【象】：豐其蔀，位不當也；日中見斗，幽不明也；遇其夷主，吉行也。",
        yaoXiang5: "【象】：六五之吉，有慶也。",
        yaoXiang6: "【象】：豐其屋，天際翔也；闚其戶，闃其无人，自藏也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "56",
        code : "001101",
        book : "下經", 
        name: "旅",
        fullName: "火山旅",
        gua: "【卦辭】：旅，小亨，旅貞吉。",
        tuan: "【彖】：旅，小亨，柔得中乎外而順乎剛，止而麗乎明，是以小亨，旅貞吉也，旅之時義大矣哉。",
        xiang: "【象】：山上有火，旅，君子以明慎用刑而不留獄。",
        yao1: "【初六】：旅瑣瑣，斯其所取災。",
        yao2: "【六二】：旅即次，懷其資，得童僕貞。",
        yao3: "【九三】：旅焚其次，喪其童僕，貞厲。",
        yao4: "【九四】：旅于處，得其資斧，我心不快。",
        yao5: "【六五】：射雉，一矢亡，終以譽命。",
        yao6: "【上九】：鳥焚其巢，旅人先笑後號咷，喪牛于易，凶。",
        yaoXiang1: "【象】：旅瑣瑣，志窮災也。",
        yaoXiang2: "【象】：得童僕貞，終无尤也。",
        yaoXiang3: "【象】：旅焚其次，亦以傷矣。以旅與下，其義喪也。",
        yaoXiang4: "【象】：旅于處，未得位也；得其資斧，心未快也。",
        yaoXiang5: "【象】：終以譽命，上逮也。",
        yaoXiang6: "【象】：以旅在上，其義焚也；喪牛于易，終莫之聞也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "57",
        code : "011011",
        book : "下經", 
        name: "巽",
        fullName: "巽為風",
        gua: "【卦辭】：巽，小亨，利有攸往，利見大人。",
        tuan: "【彖】：重巽以申命，剛巽乎中正而志行，柔皆順乎剛，是以小亨，利有攸往，利見大人。",
        xiang: "【象】：隨風，巽，君子以申命行事。",
        yao1: "【初六】：進退，利武人之貞。",
        yao2: "【九二】：巽在床下，用史巫紛若，吉无咎。",
        yao3: "【九三】：頻巽，吝。",
        yao4: "【六四】：悔亡，田獲三品。",
        yao5: "【九五】：貞吉，悔亡，无不利。无初有終，先庚三日，後庚三日，吉。",
        yao6: "【上九】：巽在床下，喪其資斧，貞凶。",
        yaoXiang1: "【象】：進退，志疑也；利武人之貞，志治也。",
        yaoXiang2: "【象】：紛若之吉，得中也。",
        yaoXiang3: "【象】：頻巽之吝，志窮也。",
        yaoXiang4: "【象】：田獲三品，有功也。",
        yaoXiang5: "【象】：九五之吉，位正中也。",
        yaoXiang6: "【象】：巽在床下，上窮也；喪其資斧，正乎凶也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "58",
        code : "110110",
        book : "下經", 
        name: "兌",
        fullName: "兌為澤",
        gua: "【卦辭】：兌，亨，利貞。",
        tuan: "【彖】：兌，說也。剛中而柔外，說以利貞，是以順乎天而應乎人。說以先民，民忘其勞，說以犯難，民忘其死，說之大，民勸矣哉。",
        xiang: "【象】：麗澤，兌。君子以朋友講習。",
        yao1: "【初九】：和兌吉。",
        yao2: "【九二】：孚兌，吉，悔亡。",
        yao3: "【六三】：來兌，凶。",
        yao4: "【九四】：商兌未寧，介疾有喜。",
        yao5: "【九五】：孚于剝，有厲。",
        yao6: "【上六】：引兌。",
        yaoXiang1: "【象】：和兌之吉，行未疑也。",
        yaoXiang2: "【象】：孚兌之吉，信志也。",
        yaoXiang3: "【象】：來兌之凶，位不當也。",
        yaoXiang4: "【象】：九四之喜，有慶也。",
        yaoXiang5: "【象】：孚于剝，位正當也。",
        yaoXiang6: "【象】：上六引兌，未光也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "59",
        code : "010011",
        book : "下經", 
        name: "渙",
        fullName: "風水渙",
        gua: "【卦辭】：渙亨，王假有廟，利涉大川，利貞。",
        tuan: "【彖】：渙亨，剛來而不窮，柔得位乎外而上同。王假有廟，王乃在中也。利涉大川，乘木有功也。",
        xiang: "【象】：風行水上，渙，先王以享于帝，立廟。",
        yao1: "【初六】：用拯馬壯，吉。",
        yao2: "【九二】：渙奔其机，悔亡。",
        yao3: "【六三】：渙其躬，无悔。",
        yao4: "【六四】：渙其群，元吉。渙有丘，匪夷所思。",
        yao5: "【九五】：渙其汗，大號，渙王居，无咎。",
        yao6: "【上九】：渙其血，去逖出，无咎。",
        yaoXiang1: "【象】：初六之吉，順也。",
        yaoXiang2: "【象】：渙奔其机，得願也。",
        yaoXiang3: "【象】：渙其躬，志在外也。",
        yaoXiang4: "【象】：渙其群，元吉，光大也。",
        yaoXiang5: "【象】：王居无咎，正位也。",
        yaoXiang6: "【象】：渙其血，遠害也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "60",
        code : "110010",
        book : "下經", 
        name: "節",
        fullName: "水澤節",
        gua: "【卦辭】：節亨。苦節，不可貞。",
        tuan: "【彖】：節亨，剛柔分而剛得中。苦節不可貞，其道窮也。說以行險，當位以節，中正以通。天地節而四時成，節以制度，不傷財，不害民。",
        xiang: "【象】：澤上有水，節。君子以制數度，議德行。",
        yao1: "【初九】：不出戶庭，无咎。",
        yao2: "【九二】：不出門庭，凶。",
        yao3: "【六三】：不節若，則嗟若，无咎。",
        yao4: "【六四】：安節，亨。",
        yao5: "【九五】：甘節，吉，往有尚。",
        yao6: "【上六】：苦節，貞凶，悔亡。",
        yaoXiang1: "【象】：不出戶庭，知通塞也。",
        yaoXiang2: "【象】：不出門庭凶，失時極也。",
        yaoXiang3: "【象】：不節之嗟，又誰咎也。",
        yaoXiang4: "【象】：安節之亨，承上道也。",
        yaoXiang5: "【象】：甘節之吉，居位中也。",
        yaoXiang6: "【象】：苦節貞凶，其道窮也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "61",
        code : "110011",
        book : "下經", 
        name: "中孚",
        fullName: "風澤中孚",
        gua: "【卦辭】：中孚，豚魚吉，利涉大川，利貞。",
        tuan: "【彖】：中孚，柔在內而剛得中，說而巽，孚，乃化邦也。豚魚吉，信及豚魚也；利涉大川，乘木舟虛也；中孚以利貞，乃應乎天也。",
        xiang: "【象】：澤上有風，中孚，君子以議獄緩死。",
        yao1: "【初九】：虞吉，有它不燕。",
        yao2: "【九二】：鳴鶴在陰，其子和之；我有好爵，吾與爾靡之。",
        yao3: "【六三】：得敵，或鼓或罷，或泣或歌。",
        yao4: "【六四】：月幾望，馬匹亡，无咎。",
        yao5: "【九五】：有孚攣如，无咎。",
        yao6: "【上九】：翰音登于天，貞凶。",
        yaoXiang1: "【象】：初九虞吉，志未變也。",
        yaoXiang2: "【象】：其子和之，中心願也。",
        yaoXiang3: "【象】：或鼓或罷，位不當也。",
        yaoXiang4: "【象】：馬匹亡，絕類上也。",
        yaoXiang5: "【象】：有孚攣如，位正當也。",
        yaoXiang6: "【象】：翰音登于天，何可長也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "62",
        code : "001100",
        book : "下經", 
        name: "小過",
        fullName: "雷山小過",
        gua: "【卦辭】：小過，亨，利貞。可小事，不可大事。飛鳥遺之音，不宜上，宜下。大吉。",
        tuan: "【彖】：小過，小者過而亨也，過以利貞，與時行也。柔得中，是以小事吉也；剛失位而不中，是以不可大事也。有飛鳥之象焉，飛鳥遺之音，不宜上，宜下，大吉，上逆而下順也。",
        xiang: "【象】：山上有雷，小過。君子以行過乎恭，喪過乎哀，用過乎儉。",
        yao1: "【初六】：飛鳥以凶。",
        yao2: "【六二】：過其祖，遇其妣，不及其君，遇其臣，无咎。",
        yao3: "【九三】：弗過防之，從或戕之，凶。",
        yao4: "【九四】：无咎，弗過遇之，往厲必戒，勿用永貞。",
        yao5: "【六五】：密雲不雨，自我西郊，公弋取彼在穴。",
        yao6: "【上六】：弗遇過之，飛鳥離之，凶，是謂災眚。",
        yaoXiang1: "【象】：飛鳥以凶，不可如何也。",
        yaoXiang2: "【象】：不及其君，臣不可過也。",
        yaoXiang3: "【象】：從或戕之，凶如何也。",
        yaoXiang4: "【象】：弗過遇之，位不當也；往厲必戒，終不可長也。",
        yaoXiang5: "【象】：密雲不雨，已上也。",
        yaoXiang6: "【象】：弗遇過之，已亢也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "63",
        code : "101010",
        book : "下經", 
        name: "既濟",
        fullName: "水火既濟",
        gua: "【卦辭】：既濟，亨小，利貞。初吉終亂。",
        tuan: "【彖】：既濟亨，小者亨也。利貞，剛柔正而位當也。初吉，柔得中也，終止則亂，其道窮也。",
        xiang: "【象】：水在火上，既濟，君子以思患而豫防之。",
        yao1: "【初九】：曳其輪，濡其尾，无咎。",
        yao2: "【六二】：婦喪其茀，勿逐，七日得。",
        yao3: "【九三】：高宗伐鬼方，三年克之，小人勿用。",
        yao4: "【六四】：繻有衣袽，終日戒。",
        yao5: "【九五】：東鄰殺牛，不如西鄰之禴祭，實受其福。",
        yao6: "【上六】：濡其首，厲。",
        yaoXiang1: "【象】：曳其輪，義无咎也。",
        yaoXiang2: "【象】：七日得，以中道也。",
        yaoXiang3: "【象】：三年克之，憊也。",
        yaoXiang4: "【象】：終日戒，有所疑也。",
        yaoXiang5: "【象】：東鄰殺牛，不如西鄰之時也，實受其福，吉大來也。",
        yaoXiang6: "【象】：濡其首厲，何可久也。",
        yong9: "",
        yong6: ""
    },
    {
        id : "64",
        code : "010101",
        book : "下經", 
        name: "未濟",
        fullName: "火水未濟",
        gua: "【卦辭】：未濟，亨。小狐汔濟，濡其尾，无攸利。",
        tuan: "【彖】：未濟亨，柔得中也；小狐汔濟，未出中也；濡其尾，无攸利，不續終也，雖不當位，剛柔應也。",
        xiang: "【象】：火在水上，未濟，君子以慎辨物居方。",
        yao1: "【初六】：濡其尾，吝。",
        yao2: "【九二】：曳其輪，貞吉。",
        yao3: "【六三】：未濟，征凶，利涉大川。",
        yao4: "【九四】：貞吉，悔亡，震用伐鬼方，三年有賞于大國。",
        yao5: "【六五】：貞吉无悔，君子之光，有孚，吉。",
        yao6: "【上九】：有孚于飲酒，无咎。濡其首，有孚，失是。",
        yaoXiang1: "【象】：濡其尾，亦不知極也。",
        yaoXiang2: "【象】：九二貞吉，中以行正也。",
        yaoXiang3: "【象】：未濟征凶，位不當也。",
        yaoXiang4: "【象】：貞吉悔亡，志行也。",
        yaoXiang5: "【象】：君子之光，其暉吉也。",
        yaoXiang6: "【象】：飲酒濡首，亦不知節也。",
        yong9: "",
        yong6: ""
    },
]